// // import {
// //   Button,
// //   Form,
// //   Input,
// //   Select,
// //   message,
// //   TreeSelect,
// //   Spin,
// //   Modal,
// //   Row,
// //   Col,
// //   InputNumber,
// //   Checkbox,
// //   Radio,
// //   DatePicker,
// //   Tooltip,
// // } from "antd";
// // import {
// //   CameraOutlined,
// //   DownloadOutlined,
// //   QrcodeOutlined,
// //   ScanOutlined,
// //   HistoryOutlined,
// // } from "@ant-design/icons";
// // import { useEffect, useRef, useState, useCallback } from "react";
// // import { useNavigate, useParams, useLocation } from "react-router-dom";
// // import Webcam from "react-webcam";
// // import dayjs from "dayjs";
// // import ExcelJS from "exceljs";
// // import { saveAs } from "file-saver";
// // import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
// // import {
// //   fetchBuildersByProductId,
// //   fetchAllBuildersByProductId,
// // } from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
// // import {
// //   fetchExecutionById,
// //   postExecution,
// //   putExecution,
// //   checkExistingExecution,
// // } from "../service/checklistExecution";

// // // jsqr loaded at runtime to avoid hard crash if not installed.
// // // Install with: npm install jsqr
// // // eslint-disable-next-line import/no-mutable-exports
// // let jsQR = null;
// // // eslint-disable-next-line
// // try {
// //   jsQR = require("jsqr");
// // } catch (e) {
// //   /* QR scanning disabled if jsqr not installed */
// // }

// // const { Option } = Select;

// // // ─── Helpers ──────────────────────────────────────────────────────────────────
// // const buildTreeData = (nodes) =>
// //   nodes.map((n) => ({
// //     title: n.productName,
// //     value: n.uuid,
// //     key: n.uuid,
// //     children: n.children ? buildTreeData(n.children) : [],
// //   }));

// // const decodeMeta = (str) => {
// //   try {
// //     return JSON.parse(str);
// //   } catch {
// //     return null;
// //   }
// // };

// // // Strip data-url prefix and return raw base64 string
// // const toRawBase64 = (src) => {
// //   if (!src) return null;
// //   const idx = src.indexOf(",");
// //   return idx >= 0 ? src.slice(idx + 1) : src;
// // };

// // // Convert base64 string → Uint8Array (for ExcelJS addImage)
// // const base64ToUint8Array = (b64) => {
// //   const binary = atob(b64);
// //   const arr = new Uint8Array(binary.length);
// //   for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
// //   return arr;
// // };

// // // Detect image extension from data-url or default to jpeg
// // const detectExt = (src) => {
// //   if (!src) return "jpeg";
// //   if (src.startsWith("data:image/png")) return "png";
// //   if (src.startsWith("data:image/gif")) return "gif";
// //   return "jpeg";
// // };

// // // ── Reconstruct grid from flat records ────────────────────────────────────────
// // const recordsToGrid = (records, colCount) => {
// //   if (!records?.length) return [];

// //   const hasMeta = records.some((r) => r.gridMeta);

// //   if (!hasMeta) {
// //     return records.map((r) => ({
// //       rowId: `row_${r.id}`,
// //       cells: [
// //         {
// //           ...r,
// //           ci: 0,
// //           colSpan: colCount,
// //           rowSpan: 1,
// //           hidden: false,
// //           cellType: "INPUT",
// //           isMandatory: r.isMandatory || false,
// //           value: r.value ?? null,
// //           liveImages: r.liveImages || [],
// //           sampleImages: (r.sampleImages || []).map((img, i) => ({
// //             uid: `si_${i}`,
// //             url: `data:image/png;base64,${img}`,
// //           })),
// //         },
// //         ...Array.from({ length: colCount - 1 }, (_, ci) => ({
// //           id: `ghost_${r.id}_${ci}`,
// //           hidden: true,
// //         })),
// //       ],
// //     }));
// //   }

// //   const maxRi =
// //     Math.max(...records.map((r) => decodeMeta(r.gridMeta)?.ri ?? 0)) + 1;

// //   const makeEmpty = (ri, ci) => ({
// //     id: `empty_${ri}_${ci}`,
// //     ri,
// //     ci,
// //     colSpan: 1,
// //     rowSpan: 1,
// //     hidden: false,
// //     cellType: "DESCRIPTION",
// //     description: "",
// //     inputType: "STRING",
// //     options: [],
// //     isMandatory: false,
// //     value: null,
// //     sampleImages: [],
// //     liveImages: [],
// //     label: "",
// //   });

// //   const grid = Array.from({ length: maxRi }, (_, ri) => ({
// //     rowId: `row_${ri}`,
// //     cells: Array.from({ length: colCount }, (_, ci) => makeEmpty(ri, ci)),
// //   }));

// //   records.forEach((r) => {
// //     const meta = decodeMeta(r.gridMeta);
// //     if (!meta) return;
// //     const cell = grid[meta.ri]?.cells[meta.ci];
// //     if (!cell) return;

// //     const cellType =
// //       meta.cellType || (meta.isHeader ? "HEADER" : "DESCRIPTION");

// //     Object.assign(cell, {
// //       ...r,
// //       ri: meta.ri,
// //       ci: meta.ci,
// //       colSpan: meta.colSpan || 1,
// //       rowSpan: meta.rowSpan || 1,
// //       cellType,
// //       label: meta.label || "",
// //       isMandatory: r.isMandatory || meta.isMandatory || false,
// //       value: r.value ?? null,
// //       liveImages: r.liveImages || [],
// //       sampleImages: (r.sampleImages || []).map((img, i) => ({
// //         uid: `si_${i}`,
// //         url: typeof img === "string" ? `data:image/png;base64,${img}` : img.url,
// //       })),
// //     });

// //     for (let dr = 0; dr < (meta.rowSpan || 1); dr++) {
// //       for (let dc = 0; dc < (meta.colSpan || 1); dc++) {
// //         if (dr === 0 && dc === 0) continue;
// //         const covered = grid[meta.ri + dr]?.cells[meta.ci + dc];
// //         if (covered) covered.hidden = true;
// //       }
// //     }
// //   });

// //   return grid;
// // };

// // const applyObservations = (grid, observations) => {
// //   if (!observations?.length) return grid;
// //   return grid.map((row) => ({
// //     ...row,
// //     cells: row.cells.map((cell) => {
// //       const obs = observations.find((o) => o.recordId === cell.id);
// //       if (!obs) return cell;
// //       return {
// //         ...cell,
// //         value: obs.value ?? cell.value,
// //         liveImages: obs.liveImages || cell.liveImages,
// //       };
// //     }),
// //   }));
// // };

// // // ─── Main Component ───────────────────────────────────────────────────────────
// // const ChecklistExecutionGridForm = ({ mode }) => {
// //   const { id } = useParams();
// //   const location = useLocation();
// //   // revisionMode passed from checklistExecution list via navigate state
// //   const navRevisionMode = location.state?.revisionMode || null;
// //   const [form] = Form.useForm();
// //   const [grid, setGrid] = useState([]);
// //   const [colCount, setColCount] = useState(5);
// //   const [editData, setEditData] = useState(null);
// //   const [products, setProducts] = useState([]);
// //   const [checklists, setChecklists] = useState([]); // unique template names
// //   const [revisions, setRevisions] = useState([]); // all revisions of selected template name
// //   const [selectedProduct, setSelectedProduct] = useState(null);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [previewSrc, setPreviewSrc] = useState(null);
// //   const [camTarget, setCamTarget] = useState(null);
// //   const [qrScanOpen, setQrScanOpen] = useState(false);
// //   const [qrError, setQrError] = useState("");
// //   // If the browser/device doesn't support `facingMode: { exact: "environment" }`
// //   // (e.g. desktop with only a front camera, or unsupported combo), we fall
// //   // back to the non-strict "environment" constraint.
// //   const [qrUseExact, setQrUseExact] = useState(true);
// //   // Gate: in "add" mode the checklist grid stays disabled until the user
// //   // confirms (via Scan QR or Check Existing) that no record already exists
// //   // for this Serial/PO. In "edit"/"view" mode (editData already loaded, or
// //   // read-only), no check is required.
// //   const [existingChecked, setExistingChecked] = useState(false);
// //   const webcamRef = useRef(null);
// //   const qrWebcamRef = useRef(null);
// //   const qrRafRef = useRef(null);
// //   const qrCanvasRef = useRef(null);
// //   const [messageApi, contextHolder] = message.useMessage();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     let c = false;
// //     fetchProduct()
// //       .then((res) => {
// //         if (!c) setProducts(buildTreeData(res.data));
// //       })
// //       .catch(() => message.error("Failed to load products"));
// //     return () => {
// //       c = true;
// //     };
// //   }, []);

// //   useEffect(() => {
// //     if (!id) return;
// //     let c = false;
// //     setIsLoading(true);
// //     fetchExecutionById(id)
// //       .then((res) => {
// //         if (!c) setEditData(res.data);
// //       })
// //       .catch(() => message.error("Failed to load execution"))
// //       .finally(() => {
// //         if (!c) setIsLoading(false);
// //       });
// //     return () => {
// //       c = true;
// //     };
// //   }, [id]);

// //   useEffect(() => {
// //     if (!editData) return;
// //     setExistingChecked(true);
// //     form.setFieldsValue({
// //       product: editData.product?.uuid,
// //       checklistName: editData.checklist?.checklistName,
// //       checklist: editData.checklist?.uuid,
// //       serialNumber: editData.serialNumber,
// //       poNumber: editData.poNumber,
// //       modelNumber: editData.modelNumber,
// //     });
// //     loadChecklists(
// //       editData.product?.uuid,
// //       editData.checklist?.uuid,
// //       editData.observations,
// //     );
// //   }, [editData]);

// //   const detectColCount = (records) => {
// //     if (!records?.length) return 1;
// //     const cols = records.map((r) => {
// //       const m = decodeMeta(r.gridMeta);
// //       return m ? m.ci + (m.colSpan || 1) : 1;
// //     });
// //     return Math.max(...cols);
// //   };

// //   const loadChecklists = async (productUuid, preselectUuid, observations) => {
// //     if (!productUuid) return;
// //     setSelectedProduct(productUuid);
// //     setIsLoading(true);
// //     try {
// //       // Fetch ALL revisions then deduplicate to unique names for the first dropdown
// //       const res = await fetchAllBuildersByProductId(productUuid);
// //       const all = res.data.data || [];

// //       // Keep only one entry per checklistName (the latest revision) for the name dropdown
// //       const nameMap = new Map();
// //       all.forEach((c) => {
// //         const existing = nameMap.get(c.checklistName);
// //         if (!existing || c.revisionNo > existing.revisionNo) {
// //           nameMap.set(c.checklistName, c);
// //         }
// //       });
// //       const uniqueNames = Array.from(nameMap.values());
// //       setChecklists(uniqueNames);

// //       // Store full list so revision dropdown can filter by name
// //       setRevisions(all);

// //       if (preselectUuid) {
// //         const selected = all.find((c) => c.uuid === preselectUuid);
// //         if (selected) {
// //           form.setFieldsValue({
// //             checklistName: selected.checklistName,
// //             checklist: selected.uuid,
// //           });
// //           applyChecklist(selected, observations);
// //         }
// //       }
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // Returns all revisions for a given checklist name
// //   const getRevisionsForName = (name) =>
// //     revisions
// //       .filter((c) => c.checklistName === name)
// //       .sort((a, b) => b.revisionNo - a.revisionNo); // newest first

// //   const applyChecklist = (checklist, observations) => {
// //     const nc = detectColCount(checklist.records || []);
// //     setColCount(nc);
// //     let g = recordsToGrid(checklist.records || [], nc);
// //     if (observations) g = applyObservations(g, observations);
// //     setGrid(g);
// //   };

// //   const patchCell = (ri, ci, patch) => {
// //     setGrid((prev) =>
// //       prev.map((row, rIdx) =>
// //         rIdx !== ri
// //           ? row
// //           : {
// //               ...row,
// //               cells: row.cells.map((c, cIdx) =>
// //                 cIdx !== ci
// //                   ? c
// //                   : {
// //                       ...c,
// //                       ...(typeof patch === "function" ? patch(c) : patch),
// //                     },
// //               ),
// //             },
// //       ),
// //     );
// //   };

// //   const capturePhoto = () => {
// //     if (!webcamRef.current || !camTarget) return;
// //     const src = webcamRef.current.getScreenshot();
// //     patchCell(camTarget.ri, camTarget.ci, (c) => ({
// //       liveImages: [...(c.liveImages || []), src],
// //     }));
// //     setCamTarget(null);
// //   };

// //   // ── QR scanner ────────────────────────────────────────────────────────────
// //   // Reads frames directly from the <video> element (no screenshot/JPEG
// //   // round-trip) for faster, sharper decoding. Uses requestAnimationFrame for
// //   // smooth, GPU-synced capture instead of a fixed setInterval.
// //   // Expected QR format: "SERIALNUMBER!PONUMBER!MODELNUMBER"
// //   const startQrScanning = useCallback(() => {
// //     setQrError("");

// //     if (!qrCanvasRef.current) {
// //       qrCanvasRef.current = document.createElement("canvas");
// //     }
// //     const canvas = qrCanvasRef.current;
// //     const ctx = canvas.getContext("2d", { willReadFrequently: true });

// //     const tick = () => {
// //       const video = qrWebcamRef.current?.video;
// //       if (!video || video.readyState !== video.HAVE_ENOUGH_DATA) {
// //         qrRafRef.current = requestAnimationFrame(tick);
// //         return;
// //       }

// //       // Use the video's native resolution for max detail. If it's very
// //       // large, downscale to keep getImageData/jsQR fast (jsQR works fine
// //       // on smaller frames and is much faster).
// //       const MAX_DIM = 1000;
// //       const vw = video.videoWidth;
// //       const vh = video.videoHeight;
// //       if (!vw || !vh) {
// //         qrRafRef.current = requestAnimationFrame(tick);
// //         return;
// //       }
// //       const scale = Math.min(1, MAX_DIM / Math.max(vw, vh));
// //       const w = Math.round(vw * scale);
// //       const h = Math.round(vh * scale);

// //       if (canvas.width !== w || canvas.height !== h) {
// //         canvas.width = w;
// //         canvas.height = h;
// //       }

// //       ctx.drawImage(video, 0, 0, w, h);
// //       const imageData = ctx.getImageData(0, 0, w, h);

// //       const code =
// //         jsQR &&
// //         jsQR(imageData.data, imageData.width, imageData.height, {
// //           inversionAttempts: "attemptBoth",
// //         });

// //       if (code?.data) {
// //         stopQrScanning();
// //         parseAndFillQr(code.data);
// //         return;
// //       }

// //       qrRafRef.current = requestAnimationFrame(tick);
// //     };

// //     qrRafRef.current = requestAnimationFrame(tick);
// //   }, []);

// //   const stopQrScanning = useCallback(() => {
// //     if (qrRafRef.current) {
// //       cancelAnimationFrame(qrRafRef.current);
// //       qrRafRef.current = null;
// //     }
// //   }, []);

// //   // Shared duplicate-record check. Looks up an existing execution for the
// //   // given checklist + PO + serial. If found, shows the "Record already
// //   // exists" modal (Edit existing / New revision) and returns true.
// //   // Returns false if no existing record was found (or the check failed),
// //   // meaning the caller should proceed as normal.
// //   const checkForExistingRecord = async ({
// //     checklistId,
// //     serial,
// //     po,
// //     onClose,
// //   }) => {
// //     if (!checklistId || !serial || !po) return false;

// //     try {
// //       const res = await checkExistingExecution({
// //         checklistId,
// //         poNumber: po,
// //         serialNumber: serial,
// //       });
// //       const existing = res?.status === 204 ? null : res?.data;

// //       if (!existing) return false;

// //       onClose?.();

// //       Modal.confirm({
// //         title: "Record already exists",
// //         icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
// //         width: 480,
// //         content: (
// //           <div style={{ fontSize: 13 }}>
// //             <p>
// //               The record already exists for{" "}
// //               <strong>{existing.checklist?.checklistName}</strong> — Serial:{" "}
// //               <strong>{existing.serialNumber}</strong>, PO:{" "}
// //               <strong>{existing.poNumber}</strong>. Do you want to edit?
// //             </p>
// //             <div
// //               style={{
// //                 marginTop: 12,
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 gap: 8,
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   padding: "10px 14px",
// //                   borderRadius: 6,
// //                   border: "1px solid #d9d9d9",
// //                   background: "#f0f5ff",
// //                 }}
// //               >
// //                 <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
// //                   Edit existing
// //                 </div>
// //                 <div style={{ fontSize: 12, color: "#666" }}>
// //                   Open the existing record (Rev {existing.revisionNo || 1}) and
// //                   correct it.
// //                 </div>
// //               </div>
// //               <div
// //                 style={{
// //                   padding: "10px 14px",
// //                   borderRadius: 6,
// //                   border: "1px solid #d9d9d9",
// //                   background: "#fff7e6",
// //                 }}
// //               >
// //                 <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
// //                   New revision
// //                 </div>
// //                 <div style={{ fontSize: 12, color: "#666" }}>
// //                   Keep the old record, create Rev{" "}
// //                   {(existing.revisionNo || 1) + 1} for re-inspection.
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         ),
// //         okText: "New revision",
// //         cancelText: "Edit existing",
// //         footer: (_, { OkBtn, CancelBtn }) => (
// //           <>
// //             <Button onClick={() => Modal.destroyAll()}>Cancel</Button>
// //             <CancelBtn />
// //             <OkBtn />
// //           </>
// //         ),
// //         onOk: () =>
// //           navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
// //             state: { revisionMode: "REVISION" },
// //           }),
// //         onCancel: () =>
// //           navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
// //             state: { revisionMode: "EDIT" },
// //           }),
// //       });
// //       return true;
// //     } catch {
// //       // If the existence check fails, fall through and let the normal
// //       // submit-time duplicate check (409 DUPLICATE) handle it.
// //       return false;
// //     }
// //   };

// //   const parseAndFillQr = async (raw) => {
// //     // Expected: "SERIALNUMBER!PONUMBER!MODELNUMBER"
// //     const parts = raw.split("!");
// //     if (parts.length !== 3) {
// //       setQrError(
// //         `Invalid QR format. Expected 3 values separated by "!". Got: "${raw}"`,
// //       );
// //       startQrScanning(); // resume scanning
// //       return;
// //     }
// //     const [serial, po, model] = parts.map((p) => p.trim());

// //     const checklistId = form.getFieldValue("checklist");

// //     const found = await checkForExistingRecord({
// //       checklistId,
// //       serial,
// //       po,
// //       onClose: () => setQrScanOpen(false),
// //     });
// //     if (found) return;

// //     form.setFieldsValue({
// //       serialNumber: serial,
// //       poNumber: po,
// //       modelNumber: model,
// //     });
// //     setExistingChecked(true);
// //     setQrScanOpen(false);
// //     messageApi.open({
// //       type: "success",
// //       content: `No existing record found — QR scanned (Serial: ${serial} | PO: ${po} | Model: ${model}). You can proceed.`,
// //     });
// //   };

// //   // Manual "Check existing" button handler — for users who type Serial/PO
// //   // instead of scanning the QR code.
// //   const [checkingExisting, setCheckingExisting] = useState(false);
// //   const handleCheckExisting = async () => {
// //     const checklistId = form.getFieldValue("checklist");
// //     const serial = (form.getFieldValue("serialNumber") || "").trim();
// //     const po = (form.getFieldValue("poNumber") || "").trim();

// //     if (!checklistId) {
// //       messageApi.open({
// //         type: "warning",
// //         content: "Select checklist template and revision first",
// //       });
// //       return;
// //     }
// //     if (!serial || !po) {
// //       messageApi.open({
// //         type: "warning",
// //         content: "Enter Serial Number and PO Number first",
// //       });
// //       return;
// //     }

// //     setCheckingExisting(true);
// //     try {
// //       const found = await checkForExistingRecord({ checklistId, serial, po });
// //       if (!found) {
// //         setExistingChecked(true);
// //         messageApi.open({
// //           type: "success",
// //           content: "No existing record found — you can proceed.",
// //         });
// //       }
// //     } finally {
// //       setCheckingExisting(false);
// //     }
// //   };

// //   const openQrScanner = () => {
// //     if (!form.getFieldValue("checklist")) {
// //       messageApi.open({
// //         type: "warning",
// //         content: "Select checklist template and revision first",
// //       });
// //       return;
// //     }
// //     setQrError("");
// //     setQrUseExact(true);
// //     setQrScanOpen(true);
// //   };

// //   const closeQrScanner = () => {
// //     stopQrScanning();
// //     setQrScanOpen(false);
// //   };

// //   const onFinish = async (values) => {
// //     if (mode !== "view" && !editData && !existingChecked) {
// //       messageApi.open({
// //         type: "warning",
// //         content:
// //           "Please click \"Check Existing\" (or Scan QR) before submitting.",
// //       });
// //       return;
// //     }

// //     // Mandatory field checks — LIVE_IMAGE needs at least one captured photo;
// //     // all other input types must have a non-empty value.
// //     const allCells = grid
// //       .flatMap((row) => row.cells)
// //       .filter((c) => {
// //         if (c.hidden) return false;
// //         if (!c.id || String(c.id).startsWith("empty_")) return false;
// //         return c.cellType === "INPUT" && c.isMandatory === true;
// //       });

// //     const missingMandatoryImages = allCells.filter(
// //       (c) => c.inputType === "LIVE_IMAGE" && !c.liveImages?.length,
// //     );

// //     if (missingMandatoryImages.length > 0) {
// //       messageApi.open({
// //         type: "error",
// //         content: `${missingMandatoryImages.length} mandatory image field(s) require at least one photo.`,
// //       });
// //       return;
// //     }

// //     const isEmptyValue = (c) => {
// //       const v = c.value;
// //       if (v === null || v === undefined) return true;
// //       if (c.inputType === "OK_NOT_OK") return v !== true && v !== false;
// //       if (typeof v === "string") return v.trim() === "";
// //       return false;
// //     };

// //     const missingMandatoryFields = allCells.filter(
// //       (c) => c.inputType !== "LIVE_IMAGE" && isEmptyValue(c),
// //     );

// //     if (missingMandatoryFields.length > 0) {
// //       messageApi.open({
// //         type: "error",
// //         content: `${missingMandatoryFields.length} mandatory field(s) are empty. Please fill them before submitting.`,
// //       });
// //       return;
// //     }

// //     const observations = grid.flatMap((row) =>
// //       row.cells
// //         .filter((c) => {
// //           if (c.hidden) return false;
// //           if (!c.id || String(c.id).startsWith("empty_")) return false;
// //           return c.cellType === "INPUT";
// //         })
// //         .map((c) => ({
// //           recordId: c.id,
// //           inputType: c.inputType || "STRING",
// //           value: c.inputType === "LIVE_IMAGE" ? null : c.value,
// //           liveImages: c.inputType === "LIVE_IMAGE" ? c.liveImages || [] : [],
// //         })),
// //     );

// //     const payload = {
// //       productId: values.product,
// //       checklistId: values.checklist,
// //       serialNumber: values.serialNumber,
// //       poNumber: values.poNumber,
// //       modelNumber: values.modelNumber,
// //       observations,
// //       revisionMode: editData ? navRevisionMode || "EDIT" : null,
// //     };

// //     const resetFields = () => {
// //       // Keep product, checklist name and revision — only clear the unit-specific fields
// //       form.setFieldsValue({ serialNumber: "", poNumber: "", modelNumber: "" });
// //       setGrid((prev) =>
// //         prev.map((row) => ({
// //           ...row,
// //           cells: row.cells.map((cell) =>
// //             cell.cellType === "INPUT"
// //               ? { ...cell, value: null, liveImages: [] }
// //               : cell,
// //           ),
// //         })),
// //       );
// //     };

// //     const doSubmit = async (finalPayload) => {
// //       if (editData) {
// //         await putExecution(finalPayload, editData.id);
// //         messageApi.open({
// //           type: "success",
// //           content: "Execution saved successfully",
// //         });
// //         navigate(
// //           { pathname: "/check-list-builder/check-list" },
// //           { replace: true },
// //         );
// //       } else {
// //         await postExecution(finalPayload);
// //         messageApi.open({
// //           type: "success",
// //           content: "Execution saved successfully",
// //         });
// //         resetFields();
// //       }
// //     };

// //     setIsLoading(true);
// //     try {
// //       await doSubmit(payload);
// //     } catch (err) {
// //       const serverMsg = err?.response?.data?.message || err?.message || "";

// //       if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE_OTHER:")) {
// //         setIsLoading(false);
// //         const checklistName =
// //           revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
// //           values.checklist;

// //         Modal.error({
// //           title: "Cannot save this execution",
// //           width: 480,
// //           content: (
// //             <div style={{ fontSize: 13 }}>
// //               <p>
// //                 Another execution already exists for{" "}
// //                 <strong>{checklistName}</strong> — Serial:{" "}
// //                 <strong>{values.serialNumber}</strong>, PO:{" "}
// //                 <strong>{values.poNumber}</strong>.
// //               </p>
// //               <p style={{ marginTop: 8 }}>
// //                 Please choose a different checklist/revision for this
// //                 execution, or edit that other record directly from the
// //                 execution list.
// //               </p>
// //             </div>
// //           ),
// //           okText: "OK",
// //         });
// //       } else if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE:")) {
// //         setIsLoading(false);
// //         const checklistName =
// //           revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
// //           values.checklist;

// //         Modal.confirm({
// //           title: "Execution already exists",
// //           icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
// //           width: 480,
// //           content: (
// //             <div style={{ fontSize: 13 }}>
// //               <p>
// //                 An execution already exists for <strong>{checklistName}</strong>{" "}
// //                 — Serial: <strong>{values.serialNumber}</strong>, PO:{" "}
// //                 <strong>{values.poNumber}</strong>.
// //               </p>
// //               <div
// //                 style={{
// //                   marginTop: 12,
// //                   display: "flex",
// //                   flexDirection: "column",
// //                   gap: 8,
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     padding: "10px 14px",
// //                     borderRadius: 6,
// //                     border: "1px solid #d9d9d9",
// //                     background: "#f0f5ff",
// //                   }}
// //                 >
// //                   <div
// //                     style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
// //                   >
// //                     Edit existing
// //                   </div>
// //                   <div style={{ fontSize: 12, color: "#666" }}>
// //                     Overwrite the current execution. Use to correct a mistake.
// //                   </div>
// //                 </div>
// //                 <div
// //                   style={{
// //                     padding: "10px 14px",
// //                     borderRadius: 6,
// //                     border: "1px solid #d9d9d9",
// //                     background: "#fff7e6",
// //                   }}
// //                 >
// //                   <div
// //                     style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
// //                   >
// //                     New revision
// //                   </div>
// //                   <div style={{ fontSize: 12, color: "#666" }}>
// //                     Keep the old execution, create a new one. Use for
// //                     re-inspection.
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           ),
// //           okText: "New revision",
// //           cancelText: "Edit existing",
// //           onOk: async () => {
// //             setIsLoading(true);
// //             try {
// //               await doSubmit({ ...payload, revisionMode: "REVISION" });
// //             } catch (e2) {
// //               messageApi.open({
// //                 type: "error",
// //                 content: e2?.response?.data?.message || "Error saving",
// //               });
// //             } finally {
// //               setIsLoading(false);
// //             }
// //           },
// //           onCancel: async () => {
// //             setIsLoading(true);
// //             try {
// //               await doSubmit({ ...payload, revisionMode: "EDIT" });
// //             } catch (e2) {
// //               messageApi.open({
// //                 type: "error",
// //                 content: e2?.response?.data?.message || "Error saving",
// //               });
// //             } finally {
// //               setIsLoading(false);
// //             }
// //           },
// //         });
// //       } else {
// //         messageApi.open({
// //           type: "error",
// //           content: serverMsg || "Error saving execution",
// //         });
// //       }
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // ── Excel Download using ExcelJS (supports embedded images) ──────────────
// //   const downloadExcel = async () => {
// //     setIsLoading(true);
// //     try {
// //       const wb = new ExcelJS.Workbook();
// //       const ws = wb.addWorksheet("Execution");

// //       // ── Column widths ──────────────────────────────────────────────────────
// //       ws.columns = Array.from({ length: colCount }, () => ({ width: 28 }));

// //       // ── Helper: apply border to a cell ────────────────────────────────────
// //       const thinBorder = { style: "thin", color: { argb: "FFAAAAAA" } };
// //       const medBorder = { style: "medium", color: { argb: "FF333333" } };
// //       const applyBorder = (cell, type = "thin") => {
// //         const b = type === "medium" ? medBorder : thinBorder;
// //         cell.border = { top: b, bottom: b, left: b, right: b };
// //       };

// //       const headerFill = {
// //         type: "pattern",
// //         pattern: "solid",
// //         fgColor: { argb: "FFD6E4F0" },
// //       };
// //       const sectionFill = {
// //         type: "pattern",
// //         pattern: "solid",
// //         fgColor: { argb: "FFE8F0FE" },
// //       };
// //       const whiteFill = {
// //         type: "pattern",
// //         pattern: "solid",
// //         fgColor: { argb: "FFFFFFFF" },
// //       };

// //       // ── Row 1: Title ───────────────────────────────────────────────────────
// //       ws.mergeCells(1, 1, 1, colCount);
// //       const titleCell = ws.getCell(1, 1);
// //       titleCell.value = "Checklist Execution Report";
// //       titleCell.font = { bold: true, size: 13, color: { argb: "FF1F3864" } };
// //       titleCell.fill = headerFill;
// //       titleCell.alignment = {
// //         vertical: "middle",
// //         horizontal: "center",
// //         wrapText: true,
// //       };
// //       applyBorder(titleCell, "medium");
// //       ws.getRow(1).height = 28;

// //       // ── Row 2: blank ───────────────────────────────────────────────────────
// //       ws.getRow(2).height = 6;

// //       // ── Rows 3-6: metadata ─────────────────────────────────────────────────
// //       const meta = [
// //         ["Serial Number", editData?.serialNumber ?? ""],
// //         ["PO Number", editData?.poNumber ?? ""],
// //         ["Model Number", editData?.modelNumber ?? ""],
// //         ["Product", editData?.product?.productName ?? ""],
// //         ["Checklist", editData?.checklist?.checklistName ?? ""],
// //         [
// //           "Created Date",
// //           editData?.createdDate
// //             ? new Date(editData.createdDate).toLocaleString()
// //             : "",
// //         ],
// //       ];
// //       meta.forEach(([label, val], i) => {
// //         const rowIdx = 3 + i;
// //         const lCell = ws.getCell(rowIdx, 1);
// //         const vCell = ws.getCell(rowIdx, 2);
// //         lCell.value = label;
// //         lCell.font = { bold: true, size: 11 };
// //         vCell.value = val;
// //         vCell.font = { size: 11 };
// //         [lCell, vCell].forEach((c) => {
// //           c.alignment = { vertical: "middle", wrapText: true };
// //           applyBorder(c);
// //         });
// //         ws.getRow(rowIdx).height = 18;
// //       });

// //       // ── Row 7: blank ───────────────────────────────────────────────────────
// //       ws.getRow(7).height = 6;

// //       // ── INFO_ROWS = 9 (row1=title, row2=blank, rows3-8=6 meta, row9=blank) ──
// //       const INFO_ROWS = 9;

// //       // ── Track merged cells for rowSpan ────────────────────────────────────
// //       const mergedCells = new Set();

// //       // ── Helper: get natural pixel dimensions of an image from its data-url ──
// //       const getImageDimensions = (src) =>
// //         new Promise((resolve) => {
// //           const img = new Image();
// //           img.onload = () =>
// //             resolve({ w: img.naturalWidth, h: img.naturalHeight });
// //           img.onerror = () => resolve({ w: 200, h: 150 }); // safe fallback
// //           img.src = src;
// //         });

// //       // ── First pass: write text values and collect image info ──────────────
// //       // imageQueue: { sheetRow, sheetCol, cs, rs, src }[]
// //       const imageQueue = [];

// //       grid.forEach((row, ri) => {
// //         const sheetRow = INFO_ROWS + ri + 1; // 1-based
// //         let colCursor = 1; // 1-based

// //         row.cells.forEach((cell) => {
// //           if (cell.hidden) return;

// //           const cs = cell.colSpan || 1;
// //           const rs = cell.rowSpan || 1;
// //           const sheetCol = colCursor;

// //           for (let dr = 0; dr < rs; dr++) {
// //             for (let dc = 0; dc < cs; dc++) {
// //               if (dr === 0 && dc === 0) continue;
// //               mergedCells.add(`${sheetRow + dr}_${sheetCol + dc}`);
// //             }
// //           }

// //           if (cs > 1 || rs > 1) {
// //             ws.mergeCells(
// //               sheetRow,
// //               sheetCol,
// //               sheetRow + rs - 1,
// //               sheetCol + cs - 1,
// //             );
// //           }

// //           const wsCell = ws.getCell(sheetRow, sheetCol);
// //           wsCell.alignment = {
// //             vertical: "middle",
// //             horizontal: "left",
// //             wrapText: true,
// //           };
// //           applyBorder(wsCell);

// //           if (cell.cellType === "HEADER") {
// //             wsCell.value = cell.label || cell.description || "";
// //             wsCell.font = { bold: true, size: 11, color: { argb: "FF1677FF" } };
// //             wsCell.fill = sectionFill;
// //             wsCell.alignment = {
// //               vertical: "middle",
// //               horizontal: "center",
// //               wrapText: true,
// //             };
// //           } else if (cell.cellType === "DESCRIPTION") {
// //             wsCell.value = cell.description || "";
// //             wsCell.font = { size: 11 };
// //             wsCell.fill = whiteFill;
// //           } else if (cell.cellType === "INPUT") {
// //             wsCell.fill = {
// //               type: "pattern",
// //               pattern: "solid",
// //               fgColor: { argb: "FFFFFBE6" },
// //             };

// //             if (cell.inputType === "LIVE_IMAGE") {
// //               wsCell.value = "";
// //               (cell.liveImages || []).forEach((src) => {
// //                 imageQueue.push({ sheetRow, sheetCol, cs, rs, src });
// //               });
// //             } else if (cell.inputType === "DATE") {
// //               const v = cell.value;
// //               if (v) {
// //                 const d = dayjs(v, "DD/MM/YYYY");
// //                 wsCell.value = d.isValid() ? d.toDate() : String(v);
// //                 wsCell.numFmt = "dd/mm/yyyy";
// //               } else {
// //                 wsCell.value = "";
// //               }
// //               wsCell.font = { size: 11 };
// //             } else {
// //               const v = cell.value;
// //               if (v === null || v === undefined) wsCell.value = "";
// //               else if (typeof v === "boolean")
// //                 wsCell.value = v ? "OK" : "NOT OK";
// //               else wsCell.value = String(v);
// //               wsCell.font = { size: 11 };
// //             }
// //           } else if (cell.cellType === "IMAGE") {
// //             wsCell.value = "";
// //             wsCell.fill = {
// //               type: "pattern",
// //               pattern: "solid",
// //               fgColor: { argb: "FFF6FFED" },
// //             };
// //             (cell.sampleImages || []).forEach((img) => {
// //               imageQueue.push({ sheetRow, sheetCol, cs, rs, src: img.url });
// //             });
// //           }

// //           colCursor += cs;
// //         });

// //         // Row height set later after image dimensions are resolved
// //         ws.getRow(sheetRow).height = 20;
// //       });

// //       // ── Second pass: resolve image dimensions, set row heights, embed ──────
// //       // Group images by cell
// //       const cellImageMap = new Map();
// //       imageQueue.forEach((item) => {
// //         const key = `${item.sheetRow}_${item.sheetCol}`;
// //         if (!cellImageMap.has(key)) cellImageMap.set(key, []);
// //         cellImageMap.get(key).push(item);
// //       });

// //       // Resolve all image dimensions in parallel
// //       for (const [, items] of cellImageMap) {
// //         await Promise.all(
// //           items.map(async (item) => {
// //             item.dims = await getImageDimensions(item.src);
// //           }),
// //         );
// //       }

// //       // ── Per-row: find tallest image height, set row height in points ───────
// //       // Excel row height unit is "points". 1 point ≈ 1.333 CSS pixels.
// //       // We cap at 400pt to avoid unusably giant rows.
// //       const PX_TO_PT = 0.75; // 1px = 0.75pt  (i.e. 1pt = 1.333px)
// //       const MAX_ROW_PT = 400;
// //       const MIN_ROW_PT = 60; // minimum for any image row

// //       // rowMaxPx: sheetRow → max natural pixel height among all images in that row
// //       const rowMaxPx = new Map();
// //       for (const [, items] of cellImageMap) {
// //         for (const { sheetRow, dims } of items) {
// //           const cur = rowMaxPx.get(sheetRow) || 0;
// //           if (dims.h > cur) rowMaxPx.set(sheetRow, dims.h);
// //         }
// //       }

// //       for (const [sheetRow, maxPx] of rowMaxPx) {
// //         const pt = Math.min(Math.max(maxPx * PX_TO_PT, MIN_ROW_PT), MAX_ROW_PT);
// //         ws.getRow(sheetRow).height = pt;
// //       }

// //       // ── Per-cell: embed images side by side, sized by their aspect ratio ───
// //       // Excel column width unit is "characters" (~7px each at default font).
// //       // We approximate column pixel width as colWidth * 7 for the aspect calc.
// //       const COL_CHAR_TO_PX = 7;
// //       const COL_WIDTH_CHARS = 28; // matches ws.columns width set above
// //       const COL_WIDTH_PX = COL_WIDTH_CHARS * COL_CHAR_TO_PX; // ~196px per column

// //       for (const [, items] of cellImageMap) {
// //         const { sheetRow, sheetCol, cs, rs } = items[0];
// //         const count = items.length;

// //         // Total pixel width available for this cell
// //         const cellWidthPx = COL_WIDTH_PX * cs;
// //         // Pixel width each image slot gets
// //         const slotWidthPx = cellWidthPx / count;
// //         // Row height in pixels for this row
// //         const rowHeightPx = rowMaxPx.get(sheetRow) || 150;

// //         for (let idx = 0; idx < count; idx++) {
// //           const { src, dims } = items[idx];
// //           const raw = toRawBase64(src);
// //           const ext = detectExt(src);
// //           if (!raw) continue;

// //           // How many row-fractions tall is this image, given its aspect ratio
// //           // and the available slot width?
// //           // scaledH = height the image would be if fitted to slotWidthPx
// //           const scaledH = slotWidthPx * (dims.h / dims.w);
// //           // rowFraction = how much of the row height this image occupies
// //           // Clamp to [0, rs] so it never overflows into the next row
// //           const rowFraction = Math.min(scaledH / rowHeightPx, 1) * rs;

// //           // Column fraction: each image gets 1/count of the merged column span
// //           const colFractionStart = sheetCol - 1 + idx * (cs / count);
// //           const colFractionEnd = sheetCol - 1 + (idx + 1) * (cs / count);

// //           try {
// //             const imageId = wb.addImage({ base64: raw, extension: ext });
// //             ws.addImage(imageId, {
// //               tl: { col: colFractionStart, row: sheetRow - 1 },
// //               br: { col: colFractionEnd, row: sheetRow - 1 + rowFraction },
// //               editAs: "oneCell",
// //             });
// //           } catch (e) {
// //             const wsCell = ws.getCell(sheetRow, sheetCol);
// //             wsCell.value = `[${count} image(s)]`;
// //           }
// //         }
// //       }

// //       // ── Write and trigger download ─────────────────────────────────────────
// //       const buffer = await wb.xlsx.writeBuffer();
// //       const blob = new Blob([buffer], {
// //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
// //       });
// //       const safeSerial = (editData?.serialNumber ?? String(id)).replace(
// //         /[/\\?*[\]]/g,
// //         "_",
// //       );
// //       saveAs(blob, `checklist_execution_${safeSerial}_${Date.now()}.xlsx`);
// //     } catch (err) {
// //       console.error("Excel export error:", err);
// //       messageApi.open({
// //         type: "error",
// //         content: "Failed to generate Excel file",
// //       });
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // ── Render ────────────────────────────────────────────────────────────────
// //   return (
// //     <Spin spinning={isLoading}>
// //       {contextHolder}

// //       {/* Photo capture modal */}
// //       <Modal
// //         open={!!camTarget}
// //         title="Capture Photo"
// //         onCancel={() => setCamTarget(null)}
// //         footer={[
// //           <Button
// //             key="cap"
// //             type="primary"
// //             icon={<CameraOutlined />}
// //             onClick={capturePhoto}
// //           >
// //             Capture
// //           </Button>,
// //           <Button key="cls" onClick={() => setCamTarget(null)}>
// //             Close
// //           </Button>,
// //         ]}
// //       >
// //         <Webcam
// //           ref={webcamRef}
// //           screenshotFormat="image/jpeg"
// //           style={{ width: "100%" }}
// //         />
// //       </Modal>

// //       {/* Image preview modal */}
// //       <Modal
// //         open={!!previewSrc}
// //         footer={null}
// //         onCancel={() => setPreviewSrc(null)}
// //         title="Image Preview"
// //       >
// //         <img src={previewSrc} alt="preview" style={{ width: "100%" }} />
// //       </Modal>

// //       {/* QR Scanner modal */}
// //       <Modal
// //         open={qrScanOpen}
// //         title={
// //           <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //             <QrcodeOutlined /> Scan QR Code
// //           </span>
// //         }
// //         onCancel={closeQrScanner}
// //         afterOpenChange={(open) => {
// //           if (open) startQrScanning();
// //           else stopQrScanning();
// //         }}
// //         footer={[
// //           <Button key="cls" onClick={closeQrScanner}>
// //             Close
// //           </Button>,
// //         ]}
// //         width={480}
// //       >
// //         <div style={{ textAlign: "center" }}>
// //           {qrScanOpen && (
// //             <Webcam
// //               key={qrUseExact ? "qr-cam-exact" : "qr-cam-fallback"}
// //               ref={qrWebcamRef}
// //               screenshotFormat="image/jpeg"
// //               videoConstraints={
// //                 qrUseExact
// //                   ? {
// //                       facingMode: { exact: "environment" },
// //                       width: { ideal: 1280 },
// //                       height: { ideal: 720 },
// //                     }
// //                   : {
// //                       facingMode: "environment",
// //                       width: { ideal: 1280 },
// //                       height: { ideal: 720 },
// //                     }
// //               }
// //               onUserMediaError={() => {
// //                 // exact:"environment" not supported on this device/browser —
// //                 // retry with a non-strict constraint instead.
// //                 if (qrUseExact) setQrUseExact(false);
// //               }}
// //               style={{ width: "100%", borderRadius: 6 }}
// //             />
// //           )}
// //           <div style={{ marginTop: 8, fontSize: 12, color: "#888" }}>
// //             Point the camera at the QR code on the unit
// //           </div>
// //           {qrError && (
// //             <div
// //               style={{
// //                 marginTop: 8,
// //                 color: "#f5222d",
// //                 fontSize: 12,
// //                 background: "#fff2f0",
// //                 borderRadius: 4,
// //                 padding: "6px 10px",
// //                 border: "1px solid #ffccc7",
// //               }}
// //             >
// //               {qrError}
// //             </div>
// //           )}
// //           <div style={{ marginTop: 10, fontSize: 11, color: "#aaa" }}>
// //             Expected format: <code>SERIAL!PONUMBER!MODELNO</code>
// //           </div>
// //         </div>
// //       </Modal>

// //       <div style={{ fontWeight: 700, fontSize: "1rem", marginBottom: 12 }}>
// //         Checklist Execution
// //       </div>

// //       <Form
// //         form={form}
// //         layout="vertical"
// //         onFinish={onFinish}
// //         onValuesChange={(changed) => {
// //           if (
// //             mode !== "view" &&
// //             !editData &&
// //             ("serialNumber" in changed ||
// //               "poNumber" in changed ||
// //               "checklist" in changed)
// //           ) {
// //             setExistingChecked(false);
// //           }
// //         }}
// //       >
// //         {/* Row 1: Product + Checklist */}
// //         <Row gutter={16} style={{ marginBottom: 0 }}>
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             <Form.Item
// //               name="product"
// //               label="Select Product"
// //               rules={[{ required: true }]}
// //             >
// //               <TreeSelect
// //                 treeData={products}
// //                 placeholder="Select product"
// //                 allowClear
// //                 disabled={mode === "view"}
// //                 onChange={(val) => {
// //                   form.setFieldsValue({
// //                     checklistName: undefined,
// //                     checklist: undefined,
// //                   });
// //                   setGrid([]);
// //                   loadChecklists(val);
// //                 }}
// //               />
// //             </Form.Item>
// //           </Col>
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             {/* Step 1 — pick template name (deduplicated) */}
// //             <Form.Item
// //               name="checklistName"
// //               label="Select Checklist"
// //               rules={[{ required: true }]}
// //             >
// //               <Select
// //                 placeholder="Select checklist"
// //                 disabled={mode === "view" || !selectedProduct}
// //                 onChange={(name) => {
// //                   // Reset revision selection and clear grid when name changes
// //                   form.setFieldsValue({ checklist: undefined });
// //                   setGrid([]);
// //                   // If only one revision exists, auto-select it
// //                   const revs = getRevisionsForName(name);
// //                   if (revs.length === 1) {
// //                     form.setFieldsValue({ checklist: revs[0].uuid });
// //                     applyChecklist(revs[0]);
// //                   }
// //                 }}
// //               >
// //                 {checklists.map((c) => (
// //                   <Option key={c.checklistName} value={c.checklistName}>
// //                     {c.checklistName}
// //                   </Option>
// //                 ))}
// //               </Select>
// //             </Form.Item>
// //           </Col>
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             {/* Step 2 — pick revision (shown only when a name is selected) */}
// //             <Form.Item
// //               noStyle
// //               shouldUpdate={(prev, curr) =>
// //                 prev.checklistName !== curr.checklistName
// //               }
// //             >
// //               {({ getFieldValue }) => {
// //                 const name = getFieldValue("checklistName");
// //                 const revs = name ? getRevisionsForName(name) : [];
// //                 return (
// //                   <Form.Item
// //                     name="checklist"
// //                     label="Revision"
// //                     rules={[{ required: true }]}
// //                   >
// //                     <Select
// //                       placeholder="Select revision"
// //                       disabled={mode === "view" || !name}
// //                       onChange={(uuid) => {
// //                         const sel = revisions.find((c) => c.uuid === uuid);
// //                         if (sel) applyChecklist(sel);
// //                       }}
// //                     >
// //                       {revs.map((c) => (
// //                         <Option key={c.uuid} value={c.uuid}>
// //                           Rev {c.revisionNo}
// //                           {c.isLatest ? " ✓" : ""}
// //                         </Option>
// //                       ))}
// //                     </Select>
// //                   </Form.Item>
// //                 );
// //               }}
// //             </Form.Item>
// //           </Col>
// //           {/* QR scan button — only shown in add mode (not view or edit) */}
// //           {mode !== "view" && !editData && (
// //             <Col
// //               xs={24}
// //               sm={12}
// //               md={8}
// //               lg={6}
// //               style={{ display: "flex", alignItems: "center" }}
// //             >
// //               <Form.Item
// //                 noStyle
// //                 shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
// //               >
// //                 {({ getFieldValue }) => {
// //                   const checklistSelected = !!getFieldValue("checklist");
// //                   return (
// //                     <Form.Item label=" ">
// //                       <Tooltip
// //                         title={
// //                           checklistSelected
// //                             ? "Scan QR code to auto-fill Serial No, PO No, and Model No"
// //                             : "Select checklist template and revision first"
// //                         }
// //                       >
// //                         <Button
// //                           icon={<ScanOutlined />}
// //                           type="dashed"
// //                           disabled={!checklistSelected}
// //                           onClick={openQrScanner}
// //                           style={{ height: 32 }}
// //                         >
// //                           Scan QR
// //                         </Button>
// //                       </Tooltip>
// //                       <span
// //                         style={{ marginLeft: 10, fontSize: 11, color: "#888" }}
// //                       >
// //                         or fill manually below
// //                       </span>
// //                     </Form.Item>
// //                   );
// //                 }}
// //               </Form.Item>
// //             </Col>
// //           )}
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             <Form.Item
// //               noStyle
// //               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
// //             >
// //               {({ getFieldValue }) => {
// //                 const checklistSelected = !!getFieldValue("checklist");
// //                 return (
// //                   <Form.Item
// //                     name="serialNumber"
// //                     label="Serial Number"
// //                     rules={[
// //                       { required: true, message: "Serial number is required" },
// //                     ]}
// //                   >
// //                     <Input
// //                       disabled={
// //                         mode === "view" || !!editData || !checklistSelected
// //                       }
// //                       placeholder="e.g. BZCW220296"
// //                     />
// //                   </Form.Item>
// //                 );
// //               }}
// //             </Form.Item>
// //           </Col>
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             <Form.Item
// //               noStyle
// //               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
// //             >
// //               {({ getFieldValue }) => {
// //                 const checklistSelected = !!getFieldValue("checklist");
// //                 return (
// //                   <Form.Item
// //                     name="poNumber"
// //                     label="PO Number"
// //                     rules={[
// //                       { required: true, message: "PO number is required" },
// //                     ]}
// //                   >
// //                     <Input
// //                       disabled={
// //                         mode === "view" || !!editData || !checklistSelected
// //                       }
// //                       placeholder="e.g. 815136556"
// //                     />
// //                   </Form.Item>
// //                 );
// //               }}
// //             </Form.Item>
// //           </Col>
// //           <Col xs={24} sm={12} md={8} lg={6}>
// //             <Form.Item
// //               noStyle
// //               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
// //             >
// //               {({ getFieldValue }) => {
// //                 const checklistSelected = !!getFieldValue("checklist");
// //                 return (
// //                   <Form.Item
// //                     name="modelNumber"
// //                     label="Model Number"
// //                     rules={[
// //                       { required: true, message: "Model number is required" },
// //                     ]}
// //                   >
// //                     <Input
// //                       disabled={
// //                         mode === "view" || !!editData || !checklistSelected
// //                       }
// //                       placeholder="e.g. X990790"
// //                     />
// //                   </Form.Item>
// //                 );
// //               }}
// //             </Form.Item>
// //           </Col>
// //           {/* Manual "Check existing" button — for users typing Serial/PO
// //               instead of scanning the QR code. Triggers the same backend
// //               duplicate-check used by the QR flow. */}
// //           {mode !== "view" && !editData && (
// //             <Col
// //               xs={24}
// //               sm={12}
// //               md={8}
// //               lg={6}
// //               style={{ display: "flex", alignItems: "center" }}
// //             >
// //               <Form.Item
// //                 noStyle
// //                 shouldUpdate={(prev, curr) =>
// //                   prev.checklist !== curr.checklist ||
// //                   prev.serialNumber !== curr.serialNumber ||
// //                   prev.poNumber !== curr.poNumber
// //                 }
// //               >
// //                 {({ getFieldValue }) => {
// //                   const checklistSelected = !!getFieldValue("checklist");
// //                   const hasSerialPo =
// //                     !!getFieldValue("serialNumber") &&
// //                     !!getFieldValue("poNumber");
// //                   return (
// //                     <Form.Item label=" ">
// //                       <Tooltip
// //                         title={
// //                           checklistSelected
// //                             ? "Check if a record already exists for this Serial No + PO No"
// //                             : "Select checklist template and revision first"
// //                         }
// //                       >
// //                         <Button
// //                           icon={<HistoryOutlined />}
// //                           onClick={handleCheckExisting}
// //                           loading={checkingExisting}
// //                           disabled={!checklistSelected || !hasSerialPo}
// //                           style={{ height: 32 }}
// //                         >
// //                           Check Existing
// //                         </Button>
// //                       </Tooltip>
// //                     </Form.Item>
// //                   );
// //                 }}
// //               </Form.Item>
// //             </Col>
// //           )}
// //         </Row>

// //         {grid.length > 0 && mode !== "view" && !editData && !existingChecked && (
// //           <div
// //             style={{
// //               marginBottom: 12,
// //               padding: "8px 12px",
// //               borderRadius: 6,
// //               background: "#fffbe6",
// //               border: "1px solid #ffe58f",
// //               fontSize: 12,
// //               color: "#876800",
// //             }}
// //           >
// //             Enter Serial Number and PO Number, then click{" "}
// //             <strong>Check Existing</strong> (or use <strong>Scan QR</strong>)
// //             before filling in the checklist below.
// //           </div>
// //         )}

// //         {grid.length > 0 && (
// //           <div
// //             style={{
// //               overflowX: "auto",
// //               border: "1px solid #d9d9d9",
// //               borderRadius: 6,
// //             }}
// //           >
// //             <table
// //               style={{
// //                 borderCollapse: "collapse",
// //                 tableLayout: "fixed",
// //                 width: "100%",
// //                 minWidth: colCount * 180 + 36,
// //               }}
// //             >
// //               <thead>
// //                 <tr>
// //                   <th
// //                     style={{
// //                       width: 36,
// //                       background: "#f0f0f0",
// //                       border: "1px solid #d9d9d9",
// //                     }}
// //                   />
// //                   {Array.from({ length: colCount }, (_, ci) => (
// //                     <th
// //                       key={ci}
// //                       style={{
// //                         background: "#f0f0f0",
// //                         border: "1px solid #d9d9d9",
// //                         padding: "4px 8px",
// //                         fontSize: 11,
// //                         fontWeight: 600,
// //                         color: "#666",
// //                         textAlign: "center",
// //                       }}
// //                     >
// //                       {String.fromCharCode(65 + ci)}
// //                     </th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {grid.map((row, ri) => {
// //                   const visible = row.cells
// //                     .map((c, ci) => ({ c, ci }))
// //                     .filter(({ c }) => !c.hidden);
// //                   // In "add" mode the grid is locked until Check Existing /
// //                   // QR scan confirms no duplicate record exists.
// //                   const gridLocked =
// //                     mode !== "view" && !editData && !existingChecked;
// //                   return (
// //                     <tr key={row.rowId}>
// //                       <td
// //                         style={{
// //                           width: 36,
// //                           background: "#fafafa",
// //                           border: "1px solid #e0e0e0",
// //                           textAlign: "center",
// //                           fontSize: 10,
// //                           color: "#bbb",
// //                           verticalAlign: "middle",
// //                         }}
// //                       >
// //                         {ri + 1}
// //                       </td>
// //                       {visible.map(({ c: cell, ci }) => (
// //                         <ExecCell
// //                           key={cell.id || `cell_${ri}_${ci}`}
// //                           cell={cell}
// //                           ri={ri}
// //                           ci={ci}
// //                           mode={mode}
// //                           locked={gridLocked}
// //                           onChange={(p) => patchCell(ri, ci, p)}
// //                           onCamera={() => setCamTarget({ ri, ci })}
// //                           onPreview={setPreviewSrc}
// //                         />
// //                       ))}
// //                     </tr>
// //                   );
// //                 })}
// //               </tbody>
// //             </table>
// //           </div>
// //         )}

// //         <div
// //           style={{
// //             marginTop: 16,
// //             display: "flex",
// //             justifyContent: "flex-end",
// //             gap: 8,
// //           }}
// //         >
// //           <Button
// //             onClick={() =>
// //               navigate(
// //                 { pathname: "/check-list-builder/check-list" },
// //                 { replace: true },
// //               )
// //             }
// //           >
// //             Cancel
// //           </Button>
// //           {mode === "view" && (
// //             <Button
// //               icon={<DownloadOutlined />}
// //               onClick={downloadExcel}
// //               disabled={!editData}
// //             >
// //               Download Excel
// //             </Button>
// //           )}
// //           {mode !== "view" && (
// //             <Button type="primary" htmlType="submit">
// //               Submit
// //             </Button>
// //           )}
// //         </div>
// //       </Form>
// //     </Spin>
// //   );
// // };

// // // ─── ExecCell ─────────────────────────────────────────────────────────────────
// // const CELL_TYPE_META = {
// //   HEADER: { label: "Header", bg: "#e6f4ff", color: "#1677ff" },
// //   DESCRIPTION: { label: "Description", bg: "#f5f5f5", color: "#666" },
// //   INPUT: { label: "Input", bg: "#fffbe6", color: "#7c5b00" },
// //   IMAGE: { label: "Image", bg: "#f6ffed", color: "#237804" },
// // };

// // const INPUT_TYPE_LABEL = {
// //   STRING: "Text",
// //   DOUBLE: "Number",
// //   DATE: "Date",
// //   OK_NOT_OK: "OK / Not OK",
// //   OPTIONS: "Options",
// //   LIVE_IMAGE: "Live Image Capture",
// // };

// // const ExecCell = ({ cell, ri, ci, mode, locked, onChange, onCamera, onPreview }) => {
// //   const tdBase = {
// //     border: "1px solid #d9d9d9",
// //     verticalAlign: "top",
// //     padding: "8px 10px",
// //     boxSizing: "border-box",
// //   };

// //   switch (cell.cellType) {
// //     case "HEADER":
// //       return (
// //         <td
// //           colSpan={cell.colSpan || 1}
// //           rowSpan={cell.rowSpan || 1}
// //           style={{
// //             ...tdBase,
// //             background: "#e6f4ff",
// //             fontWeight: 700,
// //             color: "#1677ff",
// //             fontSize: 13,
// //             textAlign: "center",
// //             verticalAlign: "middle",
// //           }}
// //         >
// //           {cell.label || cell.description}
// //         </td>
// //       );

// //     case "DESCRIPTION":
// //       return (
// //         <td
// //           colSpan={cell.colSpan || 1}
// //           rowSpan={cell.rowSpan || 1}
// //           style={{
// //             ...tdBase,
// //             background: "#fff",
// //             color: "#333",
// //             fontSize: 12,
// //             lineHeight: 1.5,
// //           }}
// //         >
// //           {cell.description}
// //         </td>
// //       );

// //     case "INPUT": {
// //       const isDisabled = mode === "view" || locked;
// //       const renderWidget = () => {
// //         switch (cell.inputType) {
// //           case "OK_NOT_OK":
// //             return (
// //               <div style={{ display: "flex", gap: 12 }}>
// //                 <Checkbox
// //                   checked={cell.value === true}
// //                   disabled={isDisabled}
// //                   onChange={() =>
// //                     onChange({ value: cell.value === true ? null : true })
// //                   }
// //                 >
// //                   OK
// //                 </Checkbox>
// //                 <Checkbox
// //                   checked={cell.value === false}
// //                   disabled={isDisabled}
// //                   onChange={() =>
// //                     onChange({ value: cell.value === false ? null : false })
// //                   }
// //                 >
// //                   NOT OK
// //                 </Checkbox>
// //               </div>
// //             );

// //           case "OPTIONS":
// //             return (
// //               <Radio.Group
// //                 value={cell.value}
// //                 disabled={isDisabled}
// //                 style={{ display: "flex", flexDirection: "column", gap: 4 }}
// //                 onChange={(e) => onChange({ value: e.target.value })}
// //               >
// //                 {(cell.options || []).map((o, i) => (
// //                   <Radio key={i} value={o}>
// //                     {o}
// //                   </Radio>
// //                 ))}
// //               </Radio.Group>
// //             );

// //           case "DOUBLE":
// //             return (
// //               <InputNumber
// //                 style={{ width: "100%" }}
// //                 value={cell.value}
// //                 disabled={isDisabled}
// //                 onChange={(v) => onChange({ value: v })}
// //               />
// //             );

// //           case "DATE":
// //             return (
// //               <DatePicker
// //                 style={{ width: "100%" }}
// //                 disabled={isDisabled}
// //                 value={cell.value ? dayjs(cell.value, "DD/MM/YYYY") : null}
// //                 format="DD/MM/YYYY"
// //                 onChange={(_, dateStr) => onChange({ value: dateStr || null })}
// //               />
// //             );

// //           case "LIVE_IMAGE":
// //             return (
// //               <div>
// //                 {(cell.liveImages || []).length > 0 && (
// //                   <div
// //                     style={{
// //                       display: "flex",
// //                       gap: 4,
// //                       flexWrap: "wrap",
// //                       marginBottom: 6,
// //                     }}
// //                   >
// //                     {(cell.liveImages || []).map((src, i) => (
// //                       <div key={i} style={{ position: "relative" }}>
// //                         <img
// //                           src={src}
// //                           alt="captured"
// //                           style={{
// //                             width: "100%",
// //                             height: "auto",
// //                             objectFit: "cover",
// //                             borderRadius: 3,
// //                             cursor: "pointer",
// //                             border: "1px solid #d9d9d9",
// //                           }}
// //                           onClick={() => onPreview(src)}
// //                         />
// //                         {mode !== "view" && !locked && (
// //                           <Button
// //                             danger
// //                             type="text"
// //                             size="small"
// //                             style={{
// //                               position: "absolute",
// //                               top: -4,
// //                               right: -4,
// //                               padding: 0,
// //                               height: 16,
// //                               width: 16,
// //                               fontSize: 9,
// //                               borderRadius: "50%",
// //                               background: "#fff",
// //                               border: "1px solid #f5222d",
// //                             }}
// //                             onClick={() =>
// //                               onChange((c) => ({
// //                                 liveImages: c.liveImages.filter(
// //                                   (_, j) => j !== i,
// //                                 ),
// //                               }))
// //                             }
// //                           >
// //                             ×
// //                           </Button>
// //                         )}
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}
// //                 {mode !== "view" && !locked && (
// //                   <div
// //                     style={{ display: "flex", alignItems: "center", gap: 6 }}
// //                   >
// //                     <Button
// //                       size="small"
// //                       type="dashed"
// //                       icon={<CameraOutlined />}
// //                       style={{
// //                         fontSize: 11,
// //                         borderColor:
// //                           cell.isMandatory && !cell.liveImages?.length
// //                             ? "#ff4d4f"
// //                             : undefined,
// //                         color:
// //                           cell.isMandatory && !cell.liveImages?.length
// //                             ? "#ff4d4f"
// //                             : undefined,
// //                       }}
// //                       onClick={onCamera}
// //                     >
// //                       {cell.isMandatory ? "Capture (required)" : "Capture"}
// //                     </Button>
// //                     {cell.isMandatory && !cell.liveImages?.length && (
// //                       <span style={{ fontSize: 10, color: "#ff4d4f" }}>
// //                         At least 1 photo required
// //                       </span>
// //                     )}
// //                   </div>
// //                 )}
// //                 {(mode === "view" || locked) && !cell.liveImages?.length && (
// //                   <span style={{ fontSize: 11, color: "#bbb" }}>
// //                     No images captured
// //                   </span>
// //                 )}
// //               </div>
// //             );

// //           default:
// //             return (
// //               <Input.TextArea
// //                 autoSize={{ minRows: 1, maxRows: 6 }}
// //                 value={cell.value ?? ""}
// //                 disabled={isDisabled}
// //                 onChange={(e) => onChange({ value: e.target.value })}
// //               />
// //             );
// //         }
// //       };

// //       const inputMeta = CELL_TYPE_META["INPUT"];
// //       const typeLabel =
// //         INPUT_TYPE_LABEL[cell.inputType] || cell.inputType || "Text";
// //       return (
// //         <td
// //           colSpan={cell.colSpan || 1}
// //           rowSpan={cell.rowSpan || 1}
// //           style={{ ...tdBase, background: "#fffbe6" }}
// //         >
// //           {renderWidget()}
// //           {cell.isMandatory &&
// //             cell.inputType !== "LIVE_IMAGE" &&
// //             mode !== "view" && (
// //               <div style={{ marginTop: 3, fontSize: 10, color: "#d46b08" }}>
// //                 * required
// //               </div>
// //             )}
// //         </td>
// //       );
// //     }

// //     // IMAGE: reference sample images only — NO live capture
// //     case "IMAGE":
// //       return (
// //         <td
// //           colSpan={cell.colSpan || 1}
// //           rowSpan={cell.rowSpan || 1}
// //           style={{ ...tdBase, background: "#f6ffed" }}
// //         >
// //           {cell.sampleImages?.length > 0 ? (
// //             <div>
// //               <div style={{ fontSize: 10, color: "#888", marginBottom: 4 }}>
// //                 Reference
// //               </div>
// //               <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
// //                 {cell.sampleImages.map((img, i) => (
// //                   <img
// //                     key={i}
// //                     src={img.url}
// //                     alt="ref"
// //                     style={{
// //                       width: "100%",
// //                       height: "auto",
// //                       objectFit: "cover",
// //                       borderRadius: 3,
// //                       cursor: "pointer",
// //                       border: "1px solid #b7eb8f",
// //                       opacity: 0.85,
// //                     }}
// //                     onClick={() => onPreview(img.url)}
// //                   />
// //                 ))}
// //               </div>
// //             </div>
// //           ) : (
// //             <span style={{ fontSize: 11, color: "#bbb" }}>
// //               No reference images
// //             </span>
// //           )}
// //         </td>
// //       );

// //     default:
// //       return (
// //         <td
// //           colSpan={cell.colSpan || 1}
// //           rowSpan={cell.rowSpan || 1}
// //           style={{ ...tdBase, background: "#fff" }}
// //         />
// //       );
// //   }
// // };

// // export default ChecklistExecutionGridForm;

// import {
//   Button,
//   Form,
//   Input,
//   Select,
//   message,
//   TreeSelect,
//   Spin,
//   Modal,
//   Row,
//   Col,
//   InputNumber,
//   Checkbox,
//   Radio,
//   DatePicker,
//   Tooltip,
// } from "antd";
// import {
//   CameraOutlined,
//   DownloadOutlined,
//   QrcodeOutlined,
//   ScanOutlined,
//   HistoryOutlined,
// } from "@ant-design/icons";
// import { useEffect, useRef, useState, useCallback } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import Webcam from "react-webcam";
// import dayjs from "dayjs";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
// import {
//   fetchBuildersByProductId,
//   fetchAllBuildersByProductId,
// } from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
// import {
//   fetchExecutionById,
//   postExecution,
//   putExecution,
//   checkExistingExecution,
// } from "../service/checklistExecution";

// // jsqr loaded at runtime to avoid hard crash if not installed.
// // Install with: npm install jsqr
// // eslint-disable-next-line import/no-mutable-exports
// let jsQR = null;
// // eslint-disable-next-line
// try {
//   jsQR = require("jsqr");
// } catch (e) {
//   /* QR scanning disabled if jsqr not installed */
// }

// const { Option } = Select;

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const buildTreeData = (nodes) =>
//   nodes.map((n) => ({
//     title: n.productName,
//     value: n.uuid,
//     key: n.uuid,
//     children: n.children ? buildTreeData(n.children) : [],
//   }));

// const decodeMeta = (str) => {
//   try {
//     return JSON.parse(str);
//   } catch {
//     return null;
//   }
// };

// // Strip data-url prefix and return raw base64 string
// const toRawBase64 = (src) => {
//   if (!src) return null;
//   const idx = src.indexOf(",");
//   return idx >= 0 ? src.slice(idx + 1) : src;
// };

// // Convert base64 string → Uint8Array (for ExcelJS addImage)
// const base64ToUint8Array = (b64) => {
//   const binary = atob(b64);
//   const arr = new Uint8Array(binary.length);
//   for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
//   return arr;
// };

// // Detect image extension from data-url or default to jpeg
// const detectExt = (src) => {
//   if (!src) return "jpeg";
//   if (src.startsWith("data:image/png")) return "png";
//   if (src.startsWith("data:image/gif")) return "gif";
//   return "jpeg";
// };

// // ── Reconstruct grid from flat records ────────────────────────────────────────
// const recordsToGrid = (records, colCount) => {
//   if (!records?.length) return [];

//   const hasMeta = records.some((r) => r.gridMeta);

//   if (!hasMeta) {
//     return records.map((r) => ({
//       rowId: `row_${r.id}`,
//       cells: [
//         {
//           ...r,
//           ci: 0,
//           colSpan: colCount,
//           rowSpan: 1,
//           hidden: false,
//           cellType: "INPUT",
//           isMandatory: r.isMandatory || false,
//           value: r.value ?? null,
//           liveImages: r.liveImages || [],
//           sampleImages: (r.sampleImages || []).map((img, i) => ({
//             uid: `si_${i}`,
//             url: `data:image/png;base64,${img}`,
//           })),
//         },
//         ...Array.from({ length: colCount - 1 }, (_, ci) => ({
//           id: `ghost_${r.id}_${ci}`,
//           hidden: true,
//         })),
//       ],
//     }));
//   }

//   const maxRi =
//     Math.max(...records.map((r) => decodeMeta(r.gridMeta)?.ri ?? 0)) + 1;

//   const makeEmpty = (ri, ci) => ({
//     id: `empty_${ri}_${ci}`,
//     ri,
//     ci,
//     colSpan: 1,
//     rowSpan: 1,
//     hidden: false,
//     cellType: "DESCRIPTION",
//     description: "",
//     inputType: "STRING",
//     options: [],
//     isMandatory: false,
//     value: null,
//     sampleImages: [],
//     liveImages: [],
//     label: "",
//   });

//   const grid = Array.from({ length: maxRi }, (_, ri) => ({
//     rowId: `row_${ri}`,
//     cells: Array.from({ length: colCount }, (_, ci) => makeEmpty(ri, ci)),
//   }));

//   records.forEach((r) => {
//     const meta = decodeMeta(r.gridMeta);
//     if (!meta) return;
//     const cell = grid[meta.ri]?.cells[meta.ci];
//     if (!cell) return;

//     const cellType =
//       meta.cellType || (meta.isHeader ? "HEADER" : "DESCRIPTION");

//     Object.assign(cell, {
//       ...r,
//       ri: meta.ri,
//       ci: meta.ci,
//       colSpan: meta.colSpan || 1,
//       rowSpan: meta.rowSpan || 1,
//       cellType,
//       label: meta.label || "",
//       isMandatory: r.isMandatory || meta.isMandatory || false,
//       value: r.value ?? null,
//       liveImages: r.liveImages || [],
//       sampleImages: (r.sampleImages || []).map((img, i) => ({
//         uid: `si_${i}`,
//         url: typeof img === "string" ? `data:image/png;base64,${img}` : img.url,
//       })),
//     });

//     for (let dr = 0; dr < (meta.rowSpan || 1); dr++) {
//       for (let dc = 0; dc < (meta.colSpan || 1); dc++) {
//         if (dr === 0 && dc === 0) continue;
//         const covered = grid[meta.ri + dr]?.cells[meta.ci + dc];
//         if (covered) covered.hidden = true;
//       }
//     }
//   });

//   return grid;
// };

// const applyObservations = (grid, observations) => {
//   if (!observations?.length) return grid;
//   return grid.map((row) => ({
//     ...row,
//     cells: row.cells.map((cell) => {
//       const obs = observations.find((o) => o.recordId === cell.id);
//       if (!obs) return cell;
//       return {
//         ...cell,
//         value: obs.value ?? cell.value,
//         liveImages: obs.liveImages || cell.liveImages,
//       };
//     }),
//   }));
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// const ChecklistExecutionGridForm = ({ mode }) => {
//   const { id } = useParams();
//   const location = useLocation();
//   // revisionMode passed from checklistExecution list via navigate state
//   const navRevisionMode = location.state?.revisionMode || null;
//   const [form] = Form.useForm();
//   const [grid, setGrid] = useState([]);
//   const [colCount, setColCount] = useState(5);
//   const [editData, setEditData] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [checklists, setChecklists] = useState([]); // unique template names
//   const [revisions, setRevisions] = useState([]); // all revisions of selected template name
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [previewSrc, setPreviewSrc] = useState(null);
//   const [camTarget, setCamTarget] = useState(null);
//   const [qrScanOpen, setQrScanOpen] = useState(false);
//   const [qrError, setQrError] = useState("");
//   // If the browser/device doesn't support `facingMode: { exact: "environment" }`
//   // (e.g. desktop with only a front camera, or unsupported combo), we fall
//   // back to the non-strict "environment" constraint.
//   const [qrUseExact, setQrUseExact] = useState(true);
//   // Explicit back-camera deviceId, resolved via enumerateDevices(). When set,
//   // we select the camera by deviceId instead of relying on facingMode, which
//   // is unreliable on many Android/iOS browsers.
//   const [qrDeviceId, setQrDeviceId] = useState(null);
//   const [qrDeviceList, setQrDeviceList] = useState([]); // all available video inputs
//   const [qrDeviceIdx, setQrDeviceIdx] = useState(0); // index into qrDeviceList for manual switching
//   // Gate: in "add" mode the checklist grid stays disabled until the user
//   // confirms (via Scan QR or Check Existing) that no record already exists
//   // for this Serial/PO. In "edit"/"view" mode (editData already loaded, or
//   // read-only), no check is required.
//   const [existingChecked, setExistingChecked] = useState(false);
//   const webcamRef = useRef(null);
//   const qrWebcamRef = useRef(null);
//   const qrRafRef = useRef(null);
//   const qrCanvasRef = useRef(null);
//   const [messageApi, contextHolder] = message.useMessage();
//   const navigate = useNavigate();

//   useEffect(() => {
//     let c = false;
//     fetchProduct()
//       .then((res) => {
//         if (!c) setProducts(buildTreeData(res.data));
//       })
//       .catch(() => message.error("Failed to load products"));
//     return () => {
//       c = true;
//     };
//   }, []);

//   useEffect(() => {
//     if (!id) return;
//     let c = false;
//     setIsLoading(true);
//     fetchExecutionById(id)
//       .then((res) => {
//         if (!c) setEditData(res.data);
//       })
//       .catch(() => message.error("Failed to load execution"))
//       .finally(() => {
//         if (!c) setIsLoading(false);
//       });
//     return () => {
//       c = true;
//     };
//   }, [id]);

//   useEffect(() => {
//     if (!editData) return;
//     setExistingChecked(true);
//     form.setFieldsValue({
//       product: editData.product?.uuid,
//       checklistName: editData.checklist?.checklistName,
//       checklist: editData.checklist?.uuid,
//       serialNumber: editData.serialNumber,
//       poNumber: editData.poNumber,
//       modelNumber: editData.modelNumber,
//     });
//     loadChecklists(
//       editData.product?.uuid,
//       editData.checklist?.uuid,
//       editData.observations,
//     );
//   }, [editData]);

//   const detectColCount = (records) => {
//     if (!records?.length) return 1;
//     const cols = records.map((r) => {
//       const m = decodeMeta(r.gridMeta);
//       return m ? m.ci + (m.colSpan || 1) : 1;
//     });
//     return Math.max(...cols);
//   };

//   const loadChecklists = async (productUuid, preselectUuid, observations) => {
//     if (!productUuid) return;
//     setSelectedProduct(productUuid);
//     setIsLoading(true);
//     try {
//       // Fetch ALL revisions then deduplicate to unique names for the first dropdown
//       const res = await fetchAllBuildersByProductId(productUuid);
//       const all = res.data.data || [];

//       // Keep only one entry per checklistName (the latest revision) for the name dropdown
//       const nameMap = new Map();
//       all.forEach((c) => {
//         const existing = nameMap.get(c.checklistName);
//         if (!existing || c.revisionNo > existing.revisionNo) {
//           nameMap.set(c.checklistName, c);
//         }
//       });
//       const uniqueNames = Array.from(nameMap.values());
//       setChecklists(uniqueNames);

//       // Store full list so revision dropdown can filter by name
//       setRevisions(all);

//       if (preselectUuid) {
//         const selected = all.find((c) => c.uuid === preselectUuid);
//         if (selected) {
//           form.setFieldsValue({
//             checklistName: selected.checklistName,
//             checklist: selected.uuid,
//           });
//           applyChecklist(selected, observations);
//         }
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Returns all revisions for a given checklist name
//   const getRevisionsForName = (name) =>
//     revisions
//       .filter((c) => c.checklistName === name)
//       .sort((a, b) => b.revisionNo - a.revisionNo); // newest first

//   const applyChecklist = (checklist, observations) => {
//     const nc = detectColCount(checklist.records || []);
//     setColCount(nc);
//     let g = recordsToGrid(checklist.records || [], nc);
//     if (observations) g = applyObservations(g, observations);
//     setGrid(g);
//   };

//   const patchCell = (ri, ci, patch) => {
//     setGrid((prev) =>
//       prev.map((row, rIdx) =>
//         rIdx !== ri
//           ? row
//           : {
//               ...row,
//               cells: row.cells.map((c, cIdx) =>
//                 cIdx !== ci
//                   ? c
//                   : {
//                       ...c,
//                       ...(typeof patch === "function" ? patch(c) : patch),
//                     },
//               ),
//             },
//       ),
//     );
//   };

//   const capturePhoto = () => {
//     if (!webcamRef.current || !camTarget) return;
//     const src = webcamRef.current.getScreenshot();
//     patchCell(camTarget.ri, camTarget.ci, (c) => ({
//       liveImages: [...(c.liveImages || []), src],
//     }));
//     setCamTarget(null);
//   };

//   // ── QR scanner ────────────────────────────────────────────────────────────
//   // Reads frames directly from the <video> element (no screenshot/JPEG
//   // round-trip) for faster, sharper decoding. Uses requestAnimationFrame for
//   // smooth, GPU-synced capture instead of a fixed setInterval.
//   // Expected QR format: "SERIALNUMBER!PONUMBER!MODELNUMBER"
//   const startQrScanning = useCallback(() => {
//     setQrError("");

//     if (!qrCanvasRef.current) {
//       qrCanvasRef.current = document.createElement("canvas");
//     }
//     const canvas = qrCanvasRef.current;
//     const ctx = canvas.getContext("2d", { willReadFrequently: true });

//     const tick = () => {
//       const video = qrWebcamRef.current?.video;
//       if (!video || video.readyState !== video.HAVE_ENOUGH_DATA) {
//         qrRafRef.current = requestAnimationFrame(tick);
//         return;
//       }

//       // Use the video's native resolution for max detail. If it's very
//       // large, downscale to keep getImageData/jsQR fast (jsQR works fine
//       // on smaller frames and is much faster).
//       const MAX_DIM = 1000;
//       const vw = video.videoWidth;
//       const vh = video.videoHeight;
//       if (!vw || !vh) {
//         qrRafRef.current = requestAnimationFrame(tick);
//         return;
//       }
//       const scale = Math.min(1, MAX_DIM / Math.max(vw, vh));
//       const w = Math.round(vw * scale);
//       const h = Math.round(vh * scale);

//       if (canvas.width !== w || canvas.height !== h) {
//         canvas.width = w;
//         canvas.height = h;
//       }

//       ctx.drawImage(video, 0, 0, w, h);
//       const imageData = ctx.getImageData(0, 0, w, h);

//       const code =
//         jsQR &&
//         jsQR(imageData.data, imageData.width, imageData.height, {
//           inversionAttempts: "attemptBoth",
//         });

//       if (code?.data) {
//         stopQrScanning();
//         parseAndFillQr(code.data);
//         return;
//       }

//       qrRafRef.current = requestAnimationFrame(tick);
//     };

//     qrRafRef.current = requestAnimationFrame(tick);
//   }, []);

//   const stopQrScanning = useCallback(() => {
//     if (qrRafRef.current) {
//       cancelAnimationFrame(qrRafRef.current);
//       qrRafRef.current = null;
//     }
//   }, []);

//   // ── Camera enumeration ──────────────────────────────────────────────────
//   // facingMode-based constraints (`environment` / `exact: "environment"`)
//   // are unreliable on many Android browsers and some iOS versions — they
//   // often silently resolve to the front camera anyway. Enumerating devices
//   // and picking the back camera by deviceId is much more reliable.
//   //
//   // Strategy:
//   //  1. Request a throwaway video stream so device labels become available
//   //     (labels are empty until permission is granted at least once).
//   //  2. List all videoinput devices.
//   //  3. Try to find one whose label suggests "back"/"rear"/"environment".
//   //  4. If no label match (labels can be blank/generic on some browsers),
//   //     fall back to the LAST device in the list — on most phones the
//   //     rear camera is enumerated after the front camera.
//   //  5. Store the full device list too, so the user can manually cycle
//   //     through cameras if auto-detection picks the wrong one.
//   const detectCameras = useCallback(async () => {
//     try {
//       // Ensure permission has been granted at least once so labels populate.
//       const tmpStream = await navigator.mediaDevices.getUserMedia({
//         video: true,
//       });
//       tmpStream.getTracks().forEach((t) => t.stop());

//       const devices = await navigator.mediaDevices.enumerateDevices();
//       const videoInputs = devices.filter((d) => d.kind === "videoinput");
//       setQrDeviceList(videoInputs);

//       if (videoInputs.length === 0) {
//         setQrDeviceId(null);
//         return;
//       }

//       // Prefer a device explicitly labeled as back/rear/environment.
//       let back = videoInputs.find((d) =>
//         /back|rear|environment/i.test(d.label || ""),
//       );

//       // If nothing matched by label (common when labels are generic, e.g.
//       // "Camera 0", "Camera 1") and there's more than one camera, assume
//       // the LAST one is the rear camera — true for the vast majority of
//       // phones (front camera is usually enumerated first).
//       if (!back && videoInputs.length > 1) {
//         back = videoInputs[videoInputs.length - 1];
//       }

//       const chosen = back || videoInputs[0];
//       const chosenIdx = videoInputs.findIndex(
//         (d) => d.deviceId === chosen.deviceId,
//       );

//       setQrDeviceId(chosen.deviceId);
//       setQrDeviceIdx(chosenIdx >= 0 ? chosenIdx : 0);
//     } catch (e) {
//       // Permission denied or enumeration unsupported — fall back to
//       // facingMode-based constraints.
//       setQrDeviceId(null);
//       setQrDeviceList([]);
//     }
//   }, []);

//   // Manually cycle to the next available camera (useful if auto-detection
//   // picked the wrong one, e.g. on tablets with multiple rear cameras).
//   const switchCamera = useCallback(() => {
//     if (qrDeviceList.length < 2) return;
//     stopQrScanning();
//     const nextIdx = (qrDeviceIdx + 1) % qrDeviceList.length;
//     setQrDeviceIdx(nextIdx);
//     setQrDeviceId(qrDeviceList[nextIdx].deviceId);
//   }, [qrDeviceList, qrDeviceIdx, stopQrScanning]);

//   // Shared duplicate-record check. Looks up an existing execution for the
//   // given checklist + PO + serial. If found, shows the "Record already
//   // exists" modal (Edit existing / New revision) and returns true.
//   // Returns false if no existing record was found (or the check failed),
//   // meaning the caller should proceed as normal.
//   const checkForExistingRecord = async ({
//     checklistId,
//     serial,
//     po,
//     onClose,
//   }) => {
//     if (!checklistId || !serial || !po) return false;

//     try {
//       const res = await checkExistingExecution({
//         checklistId,
//         poNumber: po,
//         serialNumber: serial,
//       });
//       const existing = res?.status === 204 ? null : res?.data;

//       if (!existing) return false;

//       onClose?.();

//       Modal.confirm({
//         title: "Record already exists",
//         icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
//         width: 480,
//         content: (
//           <div style={{ fontSize: 13 }}>
//             <p>
//               The record already exists for{" "}
//               <strong>{existing.checklist?.checklistName}</strong> — Serial:{" "}
//               <strong>{existing.serialNumber}</strong>, PO:{" "}
//               <strong>{existing.poNumber}</strong>. Do you want to edit?
//             </p>
//             <div
//               style={{
//                 marginTop: 12,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 8,
//               }}
//             >
//               <div
//                 style={{
//                   padding: "10px 14px",
//                   borderRadius: 6,
//                   border: "1px solid #d9d9d9",
//                   background: "#f0f5ff",
//                 }}
//               >
//                 <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
//                   Edit existing
//                 </div>
//                 <div style={{ fontSize: 12, color: "#666" }}>
//                   Open the existing record (Rev {existing.revisionNo || 1}) and
//                   correct it.
//                 </div>
//               </div>
//               <div
//                 style={{
//                   padding: "10px 14px",
//                   borderRadius: 6,
//                   border: "1px solid #d9d9d9",
//                   background: "#fff7e6",
//                 }}
//               >
//                 <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
//                   New revision
//                 </div>
//                 <div style={{ fontSize: 12, color: "#666" }}>
//                   Keep the old record, create Rev{" "}
//                   {(existing.revisionNo || 1) + 1} for re-inspection.
//                 </div>
//               </div>
//             </div>
//           </div>
//         ),
//         okText: "New revision",
//         cancelText: "Edit existing",
//         footer: (_, { OkBtn, CancelBtn }) => (
//           <>
//             <Button onClick={() => Modal.destroyAll()}>Cancel</Button>
//             <CancelBtn />
//             <OkBtn />
//           </>
//         ),
//         onOk: () =>
//           navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
//             state: { revisionMode: "REVISION" },
//           }),
//         onCancel: () =>
//           navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
//             state: { revisionMode: "EDIT" },
//           }),
//       });
//       return true;
//     } catch {
//       // If the existence check fails, fall through and let the normal
//       // submit-time duplicate check (409 DUPLICATE) handle it.
//       return false;
//     }
//   };

//   const parseAndFillQr = async (raw) => {
//     // Expected: "SERIALNUMBER!PONUMBER!MODELNUMBER"
//     const parts = raw.split("!");
//     if (parts.length !== 3) {
//       setQrError(
//         `Invalid QR format. Expected 3 values separated by "!". Got: "${raw}"`,
//       );
//       startQrScanning(); // resume scanning
//       return;
//     }
//     const [serial, po, model] = parts.map((p) => p.trim());

//     const checklistId = form.getFieldValue("checklist");

//     const found = await checkForExistingRecord({
//       checklistId,
//       serial,
//       po,
//       onClose: () => setQrScanOpen(false),
//     });
//     if (found) return;

//     form.setFieldsValue({
//       serialNumber: serial,
//       poNumber: po,
//       modelNumber: model,
//     });
//     setExistingChecked(true);
//     setQrScanOpen(false);
//     messageApi.open({
//       type: "success",
//       content: `No existing record found — QR scanned (Serial: ${serial} | PO: ${po} | Model: ${model}). You can proceed.`,
//     });
//   };

//   // Manual "Check existing" button handler — for users who type Serial/PO
//   // instead of scanning the QR code.
//   const [checkingExisting, setCheckingExisting] = useState(false);
//   const handleCheckExisting = async () => {
//     const checklistId = form.getFieldValue("checklist");
//     const serial = (form.getFieldValue("serialNumber") || "").trim();
//     const po = (form.getFieldValue("poNumber") || "").trim();

//     if (!checklistId) {
//       messageApi.open({
//         type: "warning",
//         content: "Select checklist template and revision first",
//       });
//       return;
//     }
//     if (!serial || !po) {
//       messageApi.open({
//         type: "warning",
//         content: "Enter Serial Number and PO Number first",
//       });
//       return;
//     }

//     setCheckingExisting(true);
//     try {
//       const found = await checkForExistingRecord({ checklistId, serial, po });
//       if (!found) {
//         setExistingChecked(true);
//         messageApi.open({
//           type: "success",
//           content: "No existing record found — you can proceed.",
//         });
//       }
//     } finally {
//       setCheckingExisting(false);
//     }
//   };

//   const openQrScanner = () => {
//     if (!form.getFieldValue("checklist")) {
//       messageApi.open({
//         type: "warning",
//         content: "Select checklist template and revision first",
//       });
//       return;
//     }
//     setQrError("");
//     setQrUseExact(true);
//     setQrScanOpen(true);
//     // Resolve the back camera's deviceId before the Webcam mounts.
//     detectCameras();
//   };

//   const closeQrScanner = () => {
//     stopQrScanning();
//     setQrScanOpen(false);
//   };

//   const onFinish = async (values) => {
//     if (mode !== "view" && !editData && !existingChecked) {
//       messageApi.open({
//         type: "warning",
//         content:
//           "Please click \"Check Existing\" (or Scan QR) before submitting.",
//       });
//       return;
//     }

//     // Mandatory field checks — LIVE_IMAGE needs at least one captured photo;
//     // all other input types must have a non-empty value.
//     const allCells = grid
//       .flatMap((row) => row.cells)
//       .filter((c) => {
//         if (c.hidden) return false;
//         if (!c.id || String(c.id).startsWith("empty_")) return false;
//         return c.cellType === "INPUT" && c.isMandatory === true;
//       });

//     const missingMandatoryImages = allCells.filter(
//       (c) => c.inputType === "LIVE_IMAGE" && !c.liveImages?.length,
//     );

//     if (missingMandatoryImages.length > 0) {
//       messageApi.open({
//         type: "error",
//         content: `${missingMandatoryImages.length} mandatory image field(s) require at least one photo.`,
//       });
//       return;
//     }

//     const isEmptyValue = (c) => {
//       const v = c.value;
//       if (v === null || v === undefined) return true;
//       if (c.inputType === "OK_NOT_OK") return v !== true && v !== false;
//       if (typeof v === "string") return v.trim() === "";
//       return false;
//     };

//     const missingMandatoryFields = allCells.filter(
//       (c) => c.inputType !== "LIVE_IMAGE" && isEmptyValue(c),
//     );

//     if (missingMandatoryFields.length > 0) {
//       messageApi.open({
//         type: "error",
//         content: `${missingMandatoryFields.length} mandatory field(s) are empty. Please fill them before submitting.`,
//       });
//       return;
//     }

//     const observations = grid.flatMap((row) =>
//       row.cells
//         .filter((c) => {
//           if (c.hidden) return false;
//           if (!c.id || String(c.id).startsWith("empty_")) return false;
//           return c.cellType === "INPUT";
//         })
//         .map((c) => ({
//           recordId: c.id,
//           inputType: c.inputType || "STRING",
//           value: c.inputType === "LIVE_IMAGE" ? null : c.value,
//           liveImages: c.inputType === "LIVE_IMAGE" ? c.liveImages || [] : [],
//         })),
//     );

//     const payload = {
//       productId: values.product,
//       checklistId: values.checklist,
//       serialNumber: values.serialNumber,
//       poNumber: values.poNumber,
//       modelNumber: values.modelNumber,
//       observations,
//       revisionMode: editData ? navRevisionMode || "EDIT" : null,
//     };

//     const resetFields = () => {
//       // Keep product, checklist name and revision — only clear the unit-specific fields
//       form.setFieldsValue({ serialNumber: "", poNumber: "", modelNumber: "" });
//       setGrid((prev) =>
//         prev.map((row) => ({
//           ...row,
//           cells: row.cells.map((cell) =>
//             cell.cellType === "INPUT"
//               ? { ...cell, value: null, liveImages: [] }
//               : cell,
//           ),
//         })),
//       );
//     };

//     const doSubmit = async (finalPayload) => {
//       if (editData) {
//         await putExecution(finalPayload, editData.id);
//         messageApi.open({
//           type: "success",
//           content: "Execution saved successfully",
//         });
//         navigate(
//           { pathname: "/check-list-builder/check-list" },
//           { replace: true },
//         );
//       } else {
//         await postExecution(finalPayload);
//         messageApi.open({
//           type: "success",
//           content: "Execution saved successfully",
//         });
//         resetFields();
//       }
//     };

//     setIsLoading(true);
//     try {
//       await doSubmit(payload);
//     } catch (err) {
//       const serverMsg = err?.response?.data?.message || err?.message || "";

//       if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE_OTHER:")) {
//         setIsLoading(false);
//         const checklistName =
//           revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
//           values.checklist;

//         Modal.error({
//           title: "Cannot save this execution",
//           width: 480,
//           content: (
//             <div style={{ fontSize: 13 }}>
//               <p>
//                 Another execution already exists for{" "}
//                 <strong>{checklistName}</strong> — Serial:{" "}
//                 <strong>{values.serialNumber}</strong>, PO:{" "}
//                 <strong>{values.poNumber}</strong>.
//               </p>
//               <p style={{ marginTop: 8 }}>
//                 Please choose a different checklist/revision for this
//                 execution, or edit that other record directly from the
//                 execution list.
//               </p>
//             </div>
//           ),
//           okText: "OK",
//         });
//       } else if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE:")) {
//         setIsLoading(false);
//         const checklistName =
//           revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
//           values.checklist;

//         Modal.confirm({
//           title: "Execution already exists",
//           icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
//           width: 480,
//           content: (
//             <div style={{ fontSize: 13 }}>
//               <p>
//                 An execution already exists for <strong>{checklistName}</strong>{" "}
//                 — Serial: <strong>{values.serialNumber}</strong>, PO:{" "}
//                 <strong>{values.poNumber}</strong>.
//               </p>
//               <div
//                 style={{
//                   marginTop: 12,
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 8,
//                 }}
//               >
//                 <div
//                   style={{
//                     padding: "10px 14px",
//                     borderRadius: 6,
//                     border: "1px solid #d9d9d9",
//                     background: "#f0f5ff",
//                   }}
//                 >
//                   <div
//                     style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
//                   >
//                     Edit existing
//                   </div>
//                   <div style={{ fontSize: 12, color: "#666" }}>
//                     Overwrite the current execution. Use to correct a mistake.
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     padding: "10px 14px",
//                     borderRadius: 6,
//                     border: "1px solid #d9d9d9",
//                     background: "#fff7e6",
//                   }}
//                 >
//                   <div
//                     style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
//                   >
//                     New revision
//                   </div>
//                   <div style={{ fontSize: 12, color: "#666" }}>
//                     Keep the old execution, create a new one. Use for
//                     re-inspection.
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ),
//           okText: "New revision",
//           cancelText: "Edit existing",
//           onOk: async () => {
//             setIsLoading(true);
//             try {
//               await doSubmit({ ...payload, revisionMode: "REVISION" });
//             } catch (e2) {
//               messageApi.open({
//                 type: "error",
//                 content: e2?.response?.data?.message || "Error saving",
//               });
//             } finally {
//               setIsLoading(false);
//             }
//           },
//           onCancel: async () => {
//             setIsLoading(true);
//             try {
//               await doSubmit({ ...payload, revisionMode: "EDIT" });
//             } catch (e2) {
//               messageApi.open({
//                 type: "error",
//                 content: e2?.response?.data?.message || "Error saving",
//               });
//             } finally {
//               setIsLoading(false);
//             }
//           },
//         });
//       } else {
//         messageApi.open({
//           type: "error",
//           content: serverMsg || "Error saving execution",
//         });
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ── Excel Download using ExcelJS (supports embedded images) ──────────────
//   const downloadExcel = async () => {
//     setIsLoading(true);
//     try {
//       const wb = new ExcelJS.Workbook();
//       const ws = wb.addWorksheet("Execution");

//       // ── Column widths ──────────────────────────────────────────────────────
//       ws.columns = Array.from({ length: colCount }, () => ({ width: 28 }));

//       // ── Helper: apply border to a cell ────────────────────────────────────
//       const thinBorder = { style: "thin", color: { argb: "FFAAAAAA" } };
//       const medBorder = { style: "medium", color: { argb: "FF333333" } };
//       const applyBorder = (cell, type = "thin") => {
//         const b = type === "medium" ? medBorder : thinBorder;
//         cell.border = { top: b, bottom: b, left: b, right: b };
//       };

//       const headerFill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFD6E4F0" },
//       };
//       const sectionFill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFE8F0FE" },
//       };
//       const whiteFill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFFFFFFF" },
//       };

//       // ── Row 1: Title ───────────────────────────────────────────────────────
//       ws.mergeCells(1, 1, 1, colCount);
//       const titleCell = ws.getCell(1, 1);
//       titleCell.value = "Checklist Execution Report";
//       titleCell.font = { bold: true, size: 13, color: { argb: "FF1F3864" } };
//       titleCell.fill = headerFill;
//       titleCell.alignment = {
//         vertical: "middle",
//         horizontal: "center",
//         wrapText: true,
//       };
//       applyBorder(titleCell, "medium");
//       ws.getRow(1).height = 28;

//       // ── Row 2: blank ───────────────────────────────────────────────────────
//       ws.getRow(2).height = 6;

//       // ── Rows 3-6: metadata ─────────────────────────────────────────────────
//       const meta = [
//         ["Serial Number", editData?.serialNumber ?? ""],
//         ["PO Number", editData?.poNumber ?? ""],
//         ["Model Number", editData?.modelNumber ?? ""],
//         ["Product", editData?.product?.productName ?? ""],
//         ["Checklist", editData?.checklist?.checklistName ?? ""],
//         [
//           "Created Date",
//           editData?.createdDate
//             ? new Date(editData.createdDate).toLocaleString()
//             : "",
//         ],
//       ];
//       meta.forEach(([label, val], i) => {
//         const rowIdx = 3 + i;
//         const lCell = ws.getCell(rowIdx, 1);
//         const vCell = ws.getCell(rowIdx, 2);
//         lCell.value = label;
//         lCell.font = { bold: true, size: 11 };
//         vCell.value = val;
//         vCell.font = { size: 11 };
//         [lCell, vCell].forEach((c) => {
//           c.alignment = { vertical: "middle", wrapText: true };
//           applyBorder(c);
//         });
//         ws.getRow(rowIdx).height = 18;
//       });

//       // ── Row 7: blank ───────────────────────────────────────────────────────
//       ws.getRow(7).height = 6;

//       // ── INFO_ROWS = 9 (row1=title, row2=blank, rows3-8=6 meta, row9=blank) ──
//       const INFO_ROWS = 9;

//       // ── Track merged cells for rowSpan ────────────────────────────────────
//       const mergedCells = new Set();

//       // ── Helper: get natural pixel dimensions of an image from its data-url ──
//       const getImageDimensions = (src) =>
//         new Promise((resolve) => {
//           const img = new Image();
//           img.onload = () =>
//             resolve({ w: img.naturalWidth, h: img.naturalHeight });
//           img.onerror = () => resolve({ w: 200, h: 150 }); // safe fallback
//           img.src = src;
//         });

//       // ── First pass: write text values and collect image info ──────────────
//       // imageQueue: { sheetRow, sheetCol, cs, rs, src }[]
//       const imageQueue = [];

//       grid.forEach((row, ri) => {
//         const sheetRow = INFO_ROWS + ri + 1; // 1-based
//         let colCursor = 1; // 1-based

//         row.cells.forEach((cell) => {
//           if (cell.hidden) return;

//           const cs = cell.colSpan || 1;
//           const rs = cell.rowSpan || 1;
//           const sheetCol = colCursor;

//           for (let dr = 0; dr < rs; dr++) {
//             for (let dc = 0; dc < cs; dc++) {
//               if (dr === 0 && dc === 0) continue;
//               mergedCells.add(`${sheetRow + dr}_${sheetCol + dc}`);
//             }
//           }

//           if (cs > 1 || rs > 1) {
//             ws.mergeCells(
//               sheetRow,
//               sheetCol,
//               sheetRow + rs - 1,
//               sheetCol + cs - 1,
//             );
//           }

//           const wsCell = ws.getCell(sheetRow, sheetCol);
//           wsCell.alignment = {
//             vertical: "middle",
//             horizontal: "left",
//             wrapText: true,
//           };
//           applyBorder(wsCell);

//           if (cell.cellType === "HEADER") {
//             wsCell.value = cell.label || cell.description || "";
//             wsCell.font = { bold: true, size: 11, color: { argb: "FF1677FF" } };
//             wsCell.fill = sectionFill;
//             wsCell.alignment = {
//               vertical: "middle",
//               horizontal: "center",
//               wrapText: true,
//             };
//           } else if (cell.cellType === "DESCRIPTION") {
//             wsCell.value = cell.description || "";
//             wsCell.font = { size: 11 };
//             wsCell.fill = whiteFill;
//           } else if (cell.cellType === "INPUT") {
//             wsCell.fill = {
//               type: "pattern",
//               pattern: "solid",
//               fgColor: { argb: "FFFFFBE6" },
//             };

//             if (cell.inputType === "LIVE_IMAGE") {
//               wsCell.value = "";
//               (cell.liveImages || []).forEach((src) => {
//                 imageQueue.push({ sheetRow, sheetCol, cs, rs, src });
//               });
//             } else if (cell.inputType === "DATE") {
//               const v = cell.value;
//               if (v) {
//                 const d = dayjs(v, "DD/MM/YYYY");
//                 wsCell.value = d.isValid() ? d.toDate() : String(v);
//                 wsCell.numFmt = "dd/mm/yyyy";
//               } else {
//                 wsCell.value = "";
//               }
//               wsCell.font = { size: 11 };
//             } else {
//               const v = cell.value;
//               if (v === null || v === undefined) wsCell.value = "";
//               else if (typeof v === "boolean")
//                 wsCell.value = v ? "OK" : "NOT OK";
//               else wsCell.value = String(v);
//               wsCell.font = { size: 11 };
//             }
//           } else if (cell.cellType === "IMAGE") {
//             wsCell.value = "";
//             wsCell.fill = {
//               type: "pattern",
//               pattern: "solid",
//               fgColor: { argb: "FFF6FFED" },
//             };
//             (cell.sampleImages || []).forEach((img) => {
//               imageQueue.push({ sheetRow, sheetCol, cs, rs, src: img.url });
//             });
//           }

//           colCursor += cs;
//         });

//         // Row height set later after image dimensions are resolved
//         ws.getRow(sheetRow).height = 20;
//       });

//       // ── Second pass: resolve image dimensions, set row heights, embed ──────
//       // Group images by cell
//       const cellImageMap = new Map();
//       imageQueue.forEach((item) => {
//         const key = `${item.sheetRow}_${item.sheetCol}`;
//         if (!cellImageMap.has(key)) cellImageMap.set(key, []);
//         cellImageMap.get(key).push(item);
//       });

//       // Resolve all image dimensions in parallel
//       for (const [, items] of cellImageMap) {
//         await Promise.all(
//           items.map(async (item) => {
//             item.dims = await getImageDimensions(item.src);
//           }),
//         );
//       }

//       // ── Per-row: find tallest image height, set row height in points ───────
//       // Excel row height unit is "points". 1 point ≈ 1.333 CSS pixels.
//       // We cap at 400pt to avoid unusably giant rows.
//       const PX_TO_PT = 0.75; // 1px = 0.75pt  (i.e. 1pt = 1.333px)
//       const MAX_ROW_PT = 400;
//       const MIN_ROW_PT = 60; // minimum for any image row

//       // rowMaxPx: sheetRow → max natural pixel height among all images in that row
//       const rowMaxPx = new Map();
//       for (const [, items] of cellImageMap) {
//         for (const { sheetRow, dims } of items) {
//           const cur = rowMaxPx.get(sheetRow) || 0;
//           if (dims.h > cur) rowMaxPx.set(sheetRow, dims.h);
//         }
//       }

//       for (const [sheetRow, maxPx] of rowMaxPx) {
//         const pt = Math.min(Math.max(maxPx * PX_TO_PT, MIN_ROW_PT), MAX_ROW_PT);
//         ws.getRow(sheetRow).height = pt;
//       }

//       // ── Per-cell: embed images side by side, sized by their aspect ratio ───
//       // Excel column width unit is "characters" (~7px each at default font).
//       // We approximate column pixel width as colWidth * 7 for the aspect calc.
//       const COL_CHAR_TO_PX = 7;
//       const COL_WIDTH_CHARS = 28; // matches ws.columns width set above
//       const COL_WIDTH_PX = COL_WIDTH_CHARS * COL_CHAR_TO_PX; // ~196px per column

//       for (const [, items] of cellImageMap) {
//         const { sheetRow, sheetCol, cs, rs } = items[0];
//         const count = items.length;

//         // Total pixel width available for this cell
//         const cellWidthPx = COL_WIDTH_PX * cs;
//         // Pixel width each image slot gets
//         const slotWidthPx = cellWidthPx / count;
//         // Row height in pixels for this row
//         const rowHeightPx = rowMaxPx.get(sheetRow) || 150;

//         for (let idx = 0; idx < count; idx++) {
//           const { src, dims } = items[idx];
//           const raw = toRawBase64(src);
//           const ext = detectExt(src);
//           if (!raw) continue;

//           // How many row-fractions tall is this image, given its aspect ratio
//           // and the available slot width?
//           // scaledH = height the image would be if fitted to slotWidthPx
//           const scaledH = slotWidthPx * (dims.h / dims.w);
//           // rowFraction = how much of the row height this image occupies
//           // Clamp to [0, rs] so it never overflows into the next row
//           const rowFraction = Math.min(scaledH / rowHeightPx, 1) * rs;

//           // Column fraction: each image gets 1/count of the merged column span
//           const colFractionStart = sheetCol - 1 + idx * (cs / count);
//           const colFractionEnd = sheetCol - 1 + (idx + 1) * (cs / count);

//           try {
//             const imageId = wb.addImage({ base64: raw, extension: ext });
//             ws.addImage(imageId, {
//               tl: { col: colFractionStart, row: sheetRow - 1 },
//               br: { col: colFractionEnd, row: sheetRow - 1 + rowFraction },
//               editAs: "oneCell",
//             });
//           } catch (e) {
//             const wsCell = ws.getCell(sheetRow, sheetCol);
//             wsCell.value = `[${count} image(s)]`;
//           }
//         }
//       }

//       // ── Write and trigger download ─────────────────────────────────────────
//       const buffer = await wb.xlsx.writeBuffer();
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       const safeSerial = (editData?.serialNumber ?? String(id)).replace(
//         /[/\\?*[\]]/g,
//         "_",
//       );
//       saveAs(blob, `checklist_execution_${safeSerial}_${Date.now()}.xlsx`);
//     } catch (err) {
//       console.error("Excel export error:", err);
//       messageApi.open({
//         type: "error",
//         content: "Failed to generate Excel file",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <Spin spinning={isLoading}>
//       {contextHolder}

//       {/* Photo capture modal */}
//       <Modal
//         open={!!camTarget}
//         title="Capture Photo"
//         onCancel={() => setCamTarget(null)}
//         footer={[
//           <Button
//             key="cap"
//             type="primary"
//             icon={<CameraOutlined />}
//             onClick={capturePhoto}
//           >
//             Capture
//           </Button>,
//           <Button key="cls" onClick={() => setCamTarget(null)}>
//             Close
//           </Button>,
//         ]}
//       >
//         <Webcam
//           ref={webcamRef}
//           screenshotFormat="image/jpeg"
//           style={{ width: "100%" }}
//         />
//       </Modal>

//       {/* Image preview modal */}
//       <Modal
//         open={!!previewSrc}
//         footer={null}
//         onCancel={() => setPreviewSrc(null)}
//         title="Image Preview"
//       >
//         <img src={previewSrc} alt="preview" style={{ width: "100%" }} />
//       </Modal>

//       {/* QR Scanner modal */}
//       <Modal
//         open={qrScanOpen}
//         title={
//           <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
//             <QrcodeOutlined /> Scan QR Code
//           </span>
//         }
//         onCancel={closeQrScanner}
//         afterOpenChange={(open) => {
//           if (open) startQrScanning();
//           else stopQrScanning();
//         }}
//         footer={[
//           ...(qrDeviceList.length > 1
//             ? [
//                 <Button key="switch" onClick={switchCamera}>
//                   Switch Camera
//                 </Button>,
//               ]
//             : []),
//           <Button key="cls" onClick={closeQrScanner}>
//             Close
//           </Button>,
//         ]}
//         width={480}
//       >
//         <div style={{ textAlign: "center" }}>
//           {qrScanOpen && (
//             <Webcam
//               // Re-mount whenever the chosen device or fallback mode changes,
//               // so the browser re-negotiates the camera stream.
//               key={qrDeviceId || (qrUseExact ? "qr-cam-exact" : "qr-cam-fallback")}
//               ref={qrWebcamRef}
//               screenshotFormat="image/jpeg"
//               videoConstraints={
//                 qrDeviceId
//                   ? {
//                       // Preferred: select the back camera explicitly by
//                       // deviceId, resolved via enumerateDevices() in
//                       // detectCameras(). This is far more reliable than
//                       // facingMode on Android/iOS.
//                       deviceId: { exact: qrDeviceId },
//                       width: { ideal: 1280 },
//                       height: { ideal: 720 },
//                     }
//                   : qrUseExact
//                     ? {
//                         // Fallback 1: strict environment-facing camera.
//                         facingMode: { exact: "environment" },
//                         width: { ideal: 1280 },
//                         height: { ideal: 720 },
//                       }
//                     : {
//                         // Fallback 2: non-strict environment-facing camera.
//                         facingMode: "environment",
//                         width: { ideal: 1280 },
//                         height: { ideal: 720 },
//                       }
//               }
//               onUserMediaError={() => {
//                 // If the deviceId-based constraint itself fails (e.g. the
//                 // device was unplugged/changed), drop back to facingMode
//                 // constraints.
//                 if (qrDeviceId) {
//                   setQrDeviceId(null);
//                   setQrUseExact(true);
//                   return;
//                 }
//                 // exact:"environment" not supported on this device/browser —
//                 // retry with a non-strict constraint instead.
//                 if (qrUseExact) setQrUseExact(false);
//               }}
//               style={{ width: "100%", borderRadius: 6 }}
//             />
//           )}
//           <div style={{ marginTop: 8, fontSize: 12, color: "#888" }}>
//             Point the camera at the QR code on the unit
//           </div>
//           {qrError && (
//             <div
//               style={{
//                 marginTop: 8,
//                 color: "#f5222d",
//                 fontSize: 12,
//                 background: "#fff2f0",
//                 borderRadius: 4,
//                 padding: "6px 10px",
//                 border: "1px solid #ffccc7",
//               }}
//             >
//               {qrError}
//             </div>
//           )}
//           <div style={{ marginTop: 10, fontSize: 11, color: "#aaa" }}>
//             Expected format: <code>SERIAL!PONUMBER!MODELNO</code>
//           </div>
//         </div>
//       </Modal>

//       <div style={{ fontWeight: 700, fontSize: "1rem", marginBottom: 12 }}>
//         Checklist Execution
//       </div>

//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={onFinish}
//         onValuesChange={(changed) => {
//           if (
//             mode !== "view" &&
//             !editData &&
//             ("serialNumber" in changed ||
//               "poNumber" in changed ||
//               "checklist" in changed)
//           ) {
//             setExistingChecked(false);
//           }
//         }}
//       >
//         {/* Row 1: Product + Checklist */}
//         <Row gutter={16} style={{ marginBottom: 0 }}>
//           <Col xs={24} sm={12} md={8} lg={6}>
//             <Form.Item
//               name="product"
//               label="Select Product"
//               rules={[{ required: true }]}
//             >
//               <TreeSelect
//                 treeData={products}
//                 placeholder="Select product"
//                 allowClear
//                 disabled={mode === "view"}
//                 onChange={(val) => {
//                   form.setFieldsValue({
//                     checklistName: undefined,
//                     checklist: undefined,
//                   });
//                   setGrid([]);
//                   loadChecklists(val);
//                 }}
//               />
//             </Form.Item>
//           </Col>
//           <Col xs={24} sm={12} md={8} lg={6}>
//             {/* Step 1 — pick template name (deduplicated) */}
//             <Form.Item
//               name="checklistName"
//               label="Select Checklist"
//               rules={[{ required: true }]}
//             >
//               <Select
//                 placeholder="Select checklist"
//                 disabled={mode === "view" || !selectedProduct}
//                 onChange={(name) => {
//                   // Reset revision selection and clear grid when name changes
//                   form.setFieldsValue({ checklist: undefined });
//                   setGrid([]);
//                   // If only one revision exists, auto-select it
//                   const revs = getRevisionsForName(name);
//                   if (revs.length === 1) {
//                     form.setFieldsValue({ checklist: revs[0].uuid });
//                     applyChecklist(revs[0]);
//                   }
//                 }}
//               >
//                 {checklists.map((c) => (
//                   <Option key={c.checklistName} value={c.checklistName}>
//                     {c.checklistName}
//                   </Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>
//           <Col xs={24} sm={12} md={8} lg={6}>
//             {/* Step 2 — pick revision (shown only when a name is selected) */}
//             <Form.Item
//               noStyle
//               shouldUpdate={(prev, curr) =>
//                 prev.checklistName !== curr.checklistName
//               }
//             >
//               {({ getFieldValue }) => {
//                 const name = getFieldValue("checklistName");
//                 const revs = name ? getRevisionsForName(name) : [];
//                 return (
//                   <Form.Item
//                     name="checklist"
//                     label="Revision"
//                     rules={[{ required: true }]}
//                   >
//                     <Select
//                       placeholder="Select revision"
//                       disabled={mode === "view" || !name}
//                       onChange={(uuid) => {
//                         const sel = revisions.find((c) => c.uuid === uuid);
//                         if (sel) applyChecklist(sel);
//                       }}
//                     >
//                       {revs.map((c) => (
//                         <Option key={c.uuid} value={c.uuid}>
//                           Rev {c.revisionNo}
//                           {c.isLatest ? " ✓" : ""}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Form.Item>
//                 );
//               }}
//             </Form.Item>
//           </Col>
//           {/* QR scan button — only shown in add mode (not view or edit) */}
//           {mode !== "view" && !editData && (
//             <Col
//               xs={24}
//               sm={12}
//               md={8}
//               lg={6}
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <Form.Item
//                 noStyle
//                 shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
//               >
//                 {({ getFieldValue }) => {
//                   const checklistSelected = !!getFieldValue("checklist");
//                   return (
//                     <Form.Item label=" ">
//                       <Tooltip
//                         title={
//                           checklistSelected
//                             ? "Scan QR code to auto-fill Serial No, PO No, and Model No"
//                             : "Select checklist template and revision first"
//                         }
//                       >
//                         <Button
//                           icon={<ScanOutlined />}
//                           type="dashed"
//                           disabled={!checklistSelected}
//                           onClick={openQrScanner}
//                           style={{ height: 32 }}
//                         >
//                           Scan QR
//                         </Button>
//                       </Tooltip>
//                       <span
//                         style={{ marginLeft: 10, fontSize: 11, color: "#888" }}
//                       >
//                         or fill manually below
//                       </span>
//                     </Form.Item>
//                   );
//                 }}
//               </Form.Item>
//             </Col>
//           )}
//           <Col xs={24} sm={12} md={8} lg={6}>
//             <Form.Item
//               noStyle
//               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
//             >
//               {({ getFieldValue }) => {
//                 const checklistSelected = !!getFieldValue("checklist");
//                 return (
//                   <Form.Item
//                     name="serialNumber"
//                     label="Serial Number"
//                     rules={[
//                       { required: true, message: "Serial number is required" },
//                     ]}
//                   >
//                     <Input
//                       disabled={
//                         mode === "view" || !!editData || !checklistSelected
//                       }
//                       placeholder="e.g. BZCW220296"
//                     />
//                   </Form.Item>
//                 );
//               }}
//             </Form.Item>
//           </Col>
//           <Col xs={24} sm={12} md={8} lg={6}>
//             <Form.Item
//               noStyle
//               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
//             >
//               {({ getFieldValue }) => {
//                 const checklistSelected = !!getFieldValue("checklist");
//                 return (
//                   <Form.Item
//                     name="poNumber"
//                     label="PO Number"
//                     rules={[
//                       { required: true, message: "PO number is required" },
//                     ]}
//                   >
//                     <Input
//                       disabled={
//                         mode === "view" || !!editData || !checklistSelected
//                       }
//                       placeholder="e.g. 815136556"
//                     />
//                   </Form.Item>
//                 );
//               }}
//             </Form.Item>
//           </Col>
//           <Col xs={24} sm={12} md={8} lg={6}>
//             <Form.Item
//               noStyle
//               shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
//             >
//               {({ getFieldValue }) => {
//                 const checklistSelected = !!getFieldValue("checklist");
//                 return (
//                   <Form.Item
//                     name="modelNumber"
//                     label="Model Number"
//                     rules={[
//                       { required: true, message: "Model number is required" },
//                     ]}
//                   >
//                     <Input
//                       disabled={
//                         mode === "view" || !!editData || !checklistSelected
//                       }
//                       placeholder="e.g. X990790"
//                     />
//                   </Form.Item>
//                 );
//               }}
//             </Form.Item>
//           </Col>
//           {/* Manual "Check existing" button — for users typing Serial/PO
//               instead of scanning the QR code. Triggers the same backend
//               duplicate-check used by the QR flow. */}
//           {mode !== "view" && !editData && (
//             <Col
//               xs={24}
//               sm={12}
//               md={8}
//               lg={6}
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <Form.Item
//                 noStyle
//                 shouldUpdate={(prev, curr) =>
//                   prev.checklist !== curr.checklist ||
//                   prev.serialNumber !== curr.serialNumber ||
//                   prev.poNumber !== curr.poNumber
//                 }
//               >
//                 {({ getFieldValue }) => {
//                   const checklistSelected = !!getFieldValue("checklist");
//                   const hasSerialPo =
//                     !!getFieldValue("serialNumber") &&
//                     !!getFieldValue("poNumber");
//                   return (
//                     <Form.Item label=" ">
//                       <Tooltip
//                         title={
//                           checklistSelected
//                             ? "Check if a record already exists for this Serial No + PO No"
//                             : "Select checklist template and revision first"
//                         }
//                       >
//                         <Button
//                           icon={<HistoryOutlined />}
//                           onClick={handleCheckExisting}
//                           loading={checkingExisting}
//                           disabled={!checklistSelected || !hasSerialPo}
//                           style={{ height: 32 }}
//                         >
//                           Check Existing
//                         </Button>
//                       </Tooltip>
//                     </Form.Item>
//                   );
//                 }}
//               </Form.Item>
//             </Col>
//           )}
//         </Row>

//         {grid.length > 0 && mode !== "view" && !editData && !existingChecked && (
//           <div
//             style={{
//               marginBottom: 12,
//               padding: "8px 12px",
//               borderRadius: 6,
//               background: "#fffbe6",
//               border: "1px solid #ffe58f",
//               fontSize: 12,
//               color: "#876800",
//             }}
//           >
//             Enter Serial Number and PO Number, then click{" "}
//             <strong>Check Existing</strong> (or use <strong>Scan QR</strong>)
//             before filling in the checklist below.
//           </div>
//         )}

//         {grid.length > 0 && (
//           <div
//             style={{
//               overflowX: "auto",
//               border: "1px solid #d9d9d9",
//               borderRadius: 6,
//             }}
//           >
//             <table
//               style={{
//                 borderCollapse: "collapse",
//                 tableLayout: "fixed",
//                 width: "100%",
//                 minWidth: colCount * 180 + 36,
//               }}
//             >
//               <thead>
//                 <tr>
//                   <th
//                     style={{
//                       width: 36,
//                       background: "#f0f0f0",
//                       border: "1px solid #d9d9d9",
//                     }}
//                   />
//                   {Array.from({ length: colCount }, (_, ci) => (
//                     <th
//                       key={ci}
//                       style={{
//                         background: "#f0f0f0",
//                         border: "1px solid #d9d9d9",
//                         padding: "4px 8px",
//                         fontSize: 11,
//                         fontWeight: 600,
//                         color: "#666",
//                         textAlign: "center",
//                       }}
//                     >
//                       {String.fromCharCode(65 + ci)}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {grid.map((row, ri) => {
//                   const visible = row.cells
//                     .map((c, ci) => ({ c, ci }))
//                     .filter(({ c }) => !c.hidden);
//                   // In "add" mode the grid is locked until Check Existing /
//                   // QR scan confirms no duplicate record exists.
//                   const gridLocked =
//                     mode !== "view" && !editData && !existingChecked;
//                   return (
//                     <tr key={row.rowId}>
//                       <td
//                         style={{
//                           width: 36,
//                           background: "#fafafa",
//                           border: "1px solid #e0e0e0",
//                           textAlign: "center",
//                           fontSize: 10,
//                           color: "#bbb",
//                           verticalAlign: "middle",
//                         }}
//                       >
//                         {ri + 1}
//                       </td>
//                       {visible.map(({ c: cell, ci }) => (
//                         <ExecCell
//                           key={cell.id || `cell_${ri}_${ci}`}
//                           cell={cell}
//                           ri={ri}
//                           ci={ci}
//                           mode={mode}
//                           locked={gridLocked}
//                           onChange={(p) => patchCell(ri, ci, p)}
//                           onCamera={() => setCamTarget({ ri, ci })}
//                           onPreview={setPreviewSrc}
//                         />
//                       ))}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         )}

//         <div
//           style={{
//             marginTop: 16,
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 8,
//           }}
//         >
//           <Button
//             onClick={() =>
//               navigate(
//                 { pathname: "/check-list-builder/check-list" },
//                 { replace: true },
//               )
//             }
//           >
//             Cancel
//           </Button>
//           {mode === "view" && (
//             <Button
//               icon={<DownloadOutlined />}
//               onClick={downloadExcel}
//               disabled={!editData}
//             >
//               Download Excel
//             </Button>
//           )}
//           {mode !== "view" && (
//             <Button type="primary" htmlType="submit">
//               Submit
//             </Button>
//           )}
//         </div>
//       </Form>
//     </Spin>
//   );
// };

// // ─── ExecCell ─────────────────────────────────────────────────────────────────
// const CELL_TYPE_META = {
//   HEADER: { label: "Header", bg: "#e6f4ff", color: "#1677ff" },
//   DESCRIPTION: { label: "Description", bg: "#f5f5f5", color: "#666" },
//   INPUT: { label: "Input", bg: "#fffbe6", color: "#7c5b00" },
//   IMAGE: { label: "Image", bg: "#f6ffed", color: "#237804" },
// };

// const INPUT_TYPE_LABEL = {
//   STRING: "Text",
//   DOUBLE: "Number",
//   DATE: "Date",
//   OK_NOT_OK: "OK / Not OK",
//   OPTIONS: "Options",
//   LIVE_IMAGE: "Live Image Capture",
// };

// const ExecCell = ({ cell, ri, ci, mode, locked, onChange, onCamera, onPreview }) => {
//   const tdBase = {
//     border: "1px solid #d9d9d9",
//     verticalAlign: "top",
//     padding: "8px 10px",
//     boxSizing: "border-box",
//   };

//   switch (cell.cellType) {
//     case "HEADER":
//       return (
//         <td
//           colSpan={cell.colSpan || 1}
//           rowSpan={cell.rowSpan || 1}
//           style={{
//             ...tdBase,
//             background: "#e6f4ff",
//             fontWeight: 700,
//             color: "#1677ff",
//             fontSize: 13,
//             textAlign: "center",
//             verticalAlign: "middle",
//           }}
//         >
//           {cell.label || cell.description}
//         </td>
//       );

//     case "DESCRIPTION":
//       return (
//         <td
//           colSpan={cell.colSpan || 1}
//           rowSpan={cell.rowSpan || 1}
//           style={{
//             ...tdBase,
//             background: "#fff",
//             color: "#333",
//             fontSize: 12,
//             lineHeight: 1.5,
//           }}
//         >
//           {cell.description}
//         </td>
//       );

//     case "INPUT": {
//       const isDisabled = mode === "view" || locked;
//       const renderWidget = () => {
//         switch (cell.inputType) {
//           case "OK_NOT_OK":
//             return (
//               <div style={{ display: "flex", gap: 12 }}>
//                 <Checkbox
//                   checked={cell.value === true}
//                   disabled={isDisabled}
//                   onChange={() =>
//                     onChange({ value: cell.value === true ? null : true })
//                   }
//                 >
//                   OK
//                 </Checkbox>
//                 <Checkbox
//                   checked={cell.value === false}
//                   disabled={isDisabled}
//                   onChange={() =>
//                     onChange({ value: cell.value === false ? null : false })
//                   }
//                 >
//                   NOT OK
//                 </Checkbox>
//               </div>
//             );

//           case "OPTIONS":
//             return (
//               <Radio.Group
//                 value={cell.value}
//                 disabled={isDisabled}
//                 style={{ display: "flex", flexDirection: "column", gap: 4 }}
//                 onChange={(e) => onChange({ value: e.target.value })}
//               >
//                 {(cell.options || []).map((o, i) => (
//                   <Radio key={i} value={o}>
//                     {o}
//                   </Radio>
//                 ))}
//               </Radio.Group>
//             );

//           case "DOUBLE":
//             return (
//               <InputNumber
//                 style={{ width: "100%" }}
//                 value={cell.value}
//                 disabled={isDisabled}
//                 onChange={(v) => onChange({ value: v })}
//               />
//             );

//           case "DATE":
//             return (
//               <DatePicker
//                 style={{ width: "100%" }}
//                 disabled={isDisabled}
//                 value={cell.value ? dayjs(cell.value, "DD/MM/YYYY") : null}
//                 format="DD/MM/YYYY"
//                 onChange={(_, dateStr) => onChange({ value: dateStr || null })}
//               />
//             );

//           case "LIVE_IMAGE":
//             return (
//               <div>
//                 {(cell.liveImages || []).length > 0 && (
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: 4,
//                       flexWrap: "wrap",
//                       marginBottom: 6,
//                     }}
//                   >
//                     {(cell.liveImages || []).map((src, i) => (
//                       <div key={i} style={{ position: "relative" }}>
//                         <img
//                           src={src}
//                           alt="captured"
//                           style={{
//                             width: "100%",
//                             height: "auto",
//                             objectFit: "cover",
//                             borderRadius: 3,
//                             cursor: "pointer",
//                             border: "1px solid #d9d9d9",
//                           }}
//                           onClick={() => onPreview(src)}
//                         />
//                         {mode !== "view" && !locked && (
//                           <Button
//                             danger
//                             type="text"
//                             size="small"
//                             style={{
//                               position: "absolute",
//                               top: -4,
//                               right: -4,
//                               padding: 0,
//                               height: 16,
//                               width: 16,
//                               fontSize: 9,
//                               borderRadius: "50%",
//                               background: "#fff",
//                               border: "1px solid #f5222d",
//                             }}
//                             onClick={() =>
//                               onChange((c) => ({
//                                 liveImages: c.liveImages.filter(
//                                   (_, j) => j !== i,
//                                 ),
//                               }))
//                             }
//                           >
//                             ×
//                           </Button>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 {mode !== "view" && !locked && (
//                   <div
//                     style={{ display: "flex", alignItems: "center", gap: 6 }}
//                   >
//                     <Button
//                       size="small"
//                       type="dashed"
//                       icon={<CameraOutlined />}
//                       style={{
//                         fontSize: 11,
//                         borderColor:
//                           cell.isMandatory && !cell.liveImages?.length
//                             ? "#ff4d4f"
//                             : undefined,
//                         color:
//                           cell.isMandatory && !cell.liveImages?.length
//                             ? "#ff4d4f"
//                             : undefined,
//                       }}
//                       onClick={onCamera}
//                     >
//                       {cell.isMandatory ? "Capture (required)" : "Capture"}
//                     </Button>
//                     {cell.isMandatory && !cell.liveImages?.length && (
//                       <span style={{ fontSize: 10, color: "#ff4d4f" }}>
//                         At least 1 photo required
//                       </span>
//                     )}
//                   </div>
//                 )}
//                 {(mode === "view" || locked) && !cell.liveImages?.length && (
//                   <span style={{ fontSize: 11, color: "#bbb" }}>
//                     No images captured
//                   </span>
//                 )}
//               </div>
//             );

//           default:
//             return (
//               <Input.TextArea
//                 autoSize={{ minRows: 1, maxRows: 6 }}
//                 value={cell.value ?? ""}
//                 disabled={isDisabled}
//                 onChange={(e) => onChange({ value: e.target.value })}
//               />
//             );
//         }
//       };

//       const inputMeta = CELL_TYPE_META["INPUT"];
//       const typeLabel =
//         INPUT_TYPE_LABEL[cell.inputType] || cell.inputType || "Text";
//       return (
//         <td
//           colSpan={cell.colSpan || 1}
//           rowSpan={cell.rowSpan || 1}
//           style={{ ...tdBase, background: "#fffbe6" }}
//         >
//           {renderWidget()}
//           {cell.isMandatory &&
//             cell.inputType !== "LIVE_IMAGE" &&
//             mode !== "view" && (
//               <div style={{ marginTop: 3, fontSize: 10, color: "#d46b08" }}>
//                 * required
//               </div>
//             )}
//         </td>
//       );
//     }

//     // IMAGE: reference sample images only — NO live capture
//     case "IMAGE":
//       return (
//         <td
//           colSpan={cell.colSpan || 1}
//           rowSpan={cell.rowSpan || 1}
//           style={{ ...tdBase, background: "#f6ffed" }}
//         >
//           {cell.sampleImages?.length > 0 ? (
//             <div>
//               <div style={{ fontSize: 10, color: "#888", marginBottom: 4 }}>
//                 Reference
//               </div>
//               <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                 {cell.sampleImages.map((img, i) => (
//                   <img
//                     key={i}
//                     src={img.url}
//                     alt="ref"
//                     style={{
//                       width: "100%",
//                       height: "auto",
//                       objectFit: "cover",
//                       borderRadius: 3,
//                       cursor: "pointer",
//                       border: "1px solid #b7eb8f",
//                       opacity: 0.85,
//                     }}
//                     onClick={() => onPreview(img.url)}
//                   />
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <span style={{ fontSize: 11, color: "#bbb" }}>
//               No reference images
//             </span>
//           )}
//         </td>
//       );

//     default:
//       return (
//         <td
//           colSpan={cell.colSpan || 1}
//           rowSpan={cell.rowSpan || 1}
//           style={{ ...tdBase, background: "#fff" }}
//         />
//       );
//   }
// };

// export default ChecklistExecutionGridForm;

import {
  Button,
  Form,
  Input,
  Select,
  message,
  TreeSelect,
  Spin,
  Modal,
  Row,
  Col,
  InputNumber,
  Checkbox,
  Radio,
  DatePicker,
  Tooltip,
} from "antd";
import {
  CameraOutlined,
  DownloadOutlined,
  QrcodeOutlined,
  ScanOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Webcam from "react-webcam";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
import {
  fetchBuildersByProductId,
  fetchAllBuildersByProductId,
} from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
import {
  fetchExecutionById,
  postExecution,
  putExecution,
  checkExistingExecution,
} from "../service/checklistExecution";

// jsqr loaded at runtime to avoid hard crash if not installed.
// Install with: npm install jsqr
// eslint-disable-next-line import/no-mutable-exports
let jsQR = null;
// eslint-disable-next-line
try {
  jsQR = require("jsqr");
} catch (e) {
  /* QR scanning disabled if jsqr not installed */
}

const { Option } = Select;

// ─── Helpers ──────────────────────────────────────────────────────────────────
const buildTreeData = (nodes) =>
  nodes.map((n) => ({
    title: n.productName,
    value: n.uuid,
    key: n.uuid,
    children: n.children ? buildTreeData(n.children) : [],
  }));

const decodeMeta = (str) => {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
};

// Strip data-url prefix and return raw base64 string
const toRawBase64 = (src) => {
  if (!src) return null;
  const idx = src.indexOf(",");
  return idx >= 0 ? src.slice(idx + 1) : src;
};

// Convert base64 string → Uint8Array (for ExcelJS addImage)
const base64ToUint8Array = (b64) => {
  const binary = atob(b64);
  const arr = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
  return arr;
};

// Detect image extension from data-url or default to jpeg
const detectExt = (src) => {
  if (!src) return "jpeg";
  if (src.startsWith("data:image/png")) return "png";
  if (src.startsWith("data:image/gif")) return "gif";
  return "jpeg";
};

// ── Reconstruct grid from flat records ────────────────────────────────────────
const recordsToGrid = (records, colCount) => {
  if (!records?.length) return [];

  const hasMeta = records.some((r) => r.gridMeta);

  if (!hasMeta) {
    return records.map((r) => ({
      rowId: `row_${r.id}`,
      cells: [
        {
          ...r,
          ci: 0,
          colSpan: colCount,
          rowSpan: 1,
          hidden: false,
          cellType: "INPUT",
          isMandatory: r.isMandatory || false,
          value: r.value ?? null,
          liveImages: r.liveImages || [],
          sampleImages: (r.sampleImages || []).map((img, i) => ({
            uid: `si_${i}`,
            url: `data:image/png;base64,${img}`,
          })),
        },
        ...Array.from({ length: colCount - 1 }, (_, ci) => ({
          id: `ghost_${r.id}_${ci}`,
          hidden: true,
        })),
      ],
    }));
  }

  const maxRi =
    Math.max(...records.map((r) => decodeMeta(r.gridMeta)?.ri ?? 0)) + 1;

  const makeEmpty = (ri, ci) => ({
    id: `empty_${ri}_${ci}`,
    ri,
    ci,
    colSpan: 1,
    rowSpan: 1,
    hidden: false,
    cellType: "DESCRIPTION",
    description: "",
    inputType: "STRING",
    options: [],
    isMandatory: false,
    value: null,
    sampleImages: [],
    liveImages: [],
    label: "",
  });

  const grid = Array.from({ length: maxRi }, (_, ri) => ({
    rowId: `row_${ri}`,
    cells: Array.from({ length: colCount }, (_, ci) => makeEmpty(ri, ci)),
  }));

  records.forEach((r) => {
    const meta = decodeMeta(r.gridMeta);
    if (!meta) return;
    const cell = grid[meta.ri]?.cells[meta.ci];
    if (!cell) return;

    const cellType =
      meta.cellType || (meta.isHeader ? "HEADER" : "DESCRIPTION");

    Object.assign(cell, {
      ...r,
      ri: meta.ri,
      ci: meta.ci,
      colSpan: meta.colSpan || 1,
      rowSpan: meta.rowSpan || 1,
      cellType,
      label: meta.label || "",
      isMandatory: r.isMandatory || meta.isMandatory || false,
      value: r.value ?? null,
      liveImages: r.liveImages || [],
      sampleImages: (r.sampleImages || []).map((img, i) => ({
        uid: `si_${i}`,
        url: typeof img === "string" ? `data:image/png;base64,${img}` : img.url,
      })),
    });

    for (let dr = 0; dr < (meta.rowSpan || 1); dr++) {
      for (let dc = 0; dc < (meta.colSpan || 1); dc++) {
        if (dr === 0 && dc === 0) continue;
        const covered = grid[meta.ri + dr]?.cells[meta.ci + dc];
        if (covered) covered.hidden = true;
      }
    }
  });

  return grid;
};

const applyObservations = (grid, observations) => {
  if (!observations?.length) return grid;
  return grid.map((row) => ({
    ...row,
    cells: row.cells.map((cell) => {
      const obs = observations.find((o) => o.recordId === cell.id);
      if (!obs) return cell;
      return {
        ...cell,
        value: obs.value ?? cell.value,
        liveImages: obs.liveImages || cell.liveImages,
      };
    }),
  }));
};

// ─── QR Scanner: apply contrast + brightness boost to canvas context ──────────
// This dramatically improves jsQR detection on small, low-contrast codes.
// We use a simple pixel-level manipulation to increase local contrast.
//
// CHANGE 1: Added preprocessCanvas() helper.
// Why: jsQR decodes raw RGBA pixels directly. A 5mm QR code at arm's length
// occupies very few pixels and auto-exposure/white-balance makes the modules
// blurry and low-contrast. Boosting contrast before passing pixels to jsQR
// dramatically improves hit rate — this is what native scanner apps do internally.
const preprocessCanvas = (ctx, w, h) => {
  const imageData = ctx.getImageData(0, 0, w, h);
  const data = imageData.data;

  // Convert to grayscale + boost contrast via a simple linear stretch.
  // We compute min/max luminance in the frame then stretch to [0, 255].
  let minL = 255;
  let maxL = 0;
  for (let i = 0; i < data.length; i += 4) {
    // BT.601 luminance
    const l = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    if (l < minL) minL = l;
    if (l > maxL) maxL = l;
  }
  const range = maxL - minL || 1;

  for (let i = 0; i < data.length; i += 4) {
    const l = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    // Stretch contrast and apply a slight S-curve to sharpen edges
    let v = ((l - minL) / range) * 255;
    // S-curve: push values toward extremes
    v = v < 128 ? (v / 128) * (v / 128) * 128 : 255 - ((255 - v) / 128) * ((255 - v) / 128) * 128;
    v = Math.max(0, Math.min(255, Math.round(v)));
    data[i] = v;
    data[i + 1] = v;
    data[i + 2] = v;
    // alpha unchanged
  }
  ctx.putImageData(imageData, 0, 0);
};

// ─── QR Scanner: try jsQR at multiple crop scales ────────────────────────────
// CHANGE 2: Added tryDecodeMultiScale() helper.
// Why: A 5mm QR code occupies a tiny region of the full camera frame. jsQR
// searches the entire image which means the QR modules are just a few pixels
// each and the finder pattern detection fails. By also trying 2× and 4× centre
// crops we give jsQR a frame where the QR fills more of the image — exactly
// what native scanner apps do with their "zoom into centre" heuristic.
const tryDecodeMultiScale = (ctx, fullW, fullH) => {
  if (!jsQR) return null;

  // Scales to try: full frame, then progressively tighter centre crops.
  // Each crop halves the area, doubling the effective pixel density for the QR.
  const crops = [
    { x: 0, y: 0, w: fullW, h: fullH },                        // 1× full
    { x: fullW * 0.25, y: fullH * 0.25, w: fullW * 0.5, h: fullH * 0.5 }, // 2× centre
    { x: fullW * 0.375, y: fullH * 0.375, w: fullW * 0.25, h: fullH * 0.25 }, // 4× centre
  ];

  for (const crop of crops) {
    const cw = Math.round(crop.w);
    const ch = Math.round(crop.h);
    if (cw < 50 || ch < 50) continue; // too small to be useful

    // Extract the crop region into an offscreen canvas
    const offscreen = document.createElement("canvas");
    offscreen.width = cw;
    offscreen.height = ch;
    const offCtx = offscreen.getContext("2d", { willReadFrequently: true });
    // Draw the cropped region from the already-drawn main canvas
    offCtx.drawImage(
      ctx.canvas,
      Math.round(crop.x), Math.round(crop.y), cw, ch,
      0, 0, cw, ch,
    );

    // Apply contrast preprocessing to each crop independently
    preprocessCanvas(offCtx, cw, ch);

    const imageData = offCtx.getImageData(0, 0, cw, ch);
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: "attemptBoth",
    });
    if (code?.data) return code;
  }
  return null;
};

// ─── Main Component ───────────────────────────────────────────────────────────
const ChecklistExecutionGridForm = ({ mode }) => {
  const { id } = useParams();
  const location = useLocation();
  // revisionMode passed from checklistExecution list via navigate state
  const navRevisionMode = location.state?.revisionMode || null;
  const [form] = Form.useForm();
  const [grid, setGrid] = useState([]);
  const [colCount, setColCount] = useState(5);
  const [editData, setEditData] = useState(null);
  const [products, setProducts] = useState([]);
  const [checklists, setChecklists] = useState([]); // unique template names
  const [revisions, setRevisions] = useState([]); // all revisions of selected template name
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [camTarget, setCamTarget] = useState(null);
  const [qrScanOpen, setQrScanOpen] = useState(false);
  const [qrError, setQrError] = useState("");
  const [qrUseExact, setQrUseExact] = useState(true);
  const [qrDeviceId, setQrDeviceId] = useState(null);
  const [qrDeviceList, setQrDeviceList] = useState([]);
  const [qrDeviceIdx, setQrDeviceIdx] = useState(0);
  // CHANGE 3: Added qrDebugInfo state to show live feedback in the scanner UI.
  // Why: Without any feedback the user has no idea if the scanner is working
  // or if they need to hold the phone differently. Showing "Scanning…" /
  // "Frame N" reassures them the scanner is active.
  const [qrDebugInfo, setQrDebugInfo] = useState("");
  // FIX: On desktop/laptop there is typically only one camera (the front
  // webcam). The "last device = rear" heuristic that works on phones silently
  // picks the front camera on desktops. We expose a manual camera-picker
  // dropdown in the scanner modal so the user can always choose the right one.
  const [showCameraPicker, setShowCameraPicker] = useState(false);
  const [existingChecked, setExistingChecked] = useState(false);
  const webcamRef = useRef(null);
  const qrWebcamRef = useRef(null);
  const qrRafRef = useRef(null);
  const qrCanvasRef = useRef(null);
  // CHANGE 4: Added qrFrameCountRef to throttle expensive jsQR calls.
  // Why: Running jsQR + multi-scale crop on every RAF frame (~60fps) is far too
  // expensive on mobile. We run the full decode every 3rd frame (~20fps) which
  // is still fast enough for real-time scanning but prevents CPU/thermal throttle
  // that causes phones to reduce camera quality mid-scan.
  const qrFrameCountRef = useRef(0);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    let c = false;
    fetchProduct()
      .then((res) => {
        if (!c) setProducts(buildTreeData(res.data));
      })
      .catch(() => message.error("Failed to load products"));
    return () => {
      c = true;
    };
  }, []);

  useEffect(() => {
    if (!id) return;
    let c = false;
    setIsLoading(true);
    fetchExecutionById(id)
      .then((res) => {
        if (!c) setEditData(res.data);
      })
      .catch(() => message.error("Failed to load execution"))
      .finally(() => {
        if (!c) setIsLoading(false);
      });
    return () => {
      c = true;
    };
  }, [id]);

  useEffect(() => {
    if (!editData) return;
    setExistingChecked(true);
    form.setFieldsValue({
      product: editData.product?.uuid,
      checklistName: editData.checklist?.checklistName,
      checklist: editData.checklist?.uuid,
      serialNumber: editData.serialNumber,
      poNumber: editData.poNumber,
      modelNumber: editData.modelNumber,
    });
    loadChecklists(
      editData.product?.uuid,
      editData.checklist?.uuid,
      editData.observations,
    );
  }, [editData]);

  const detectColCount = (records) => {
    if (!records?.length) return 1;
    const cols = records.map((r) => {
      const m = decodeMeta(r.gridMeta);
      return m ? m.ci + (m.colSpan || 1) : 1;
    });
    return Math.max(...cols);
  };

  const loadChecklists = async (productUuid, preselectUuid, observations) => {
    if (!productUuid) return;
    setSelectedProduct(productUuid);
    setIsLoading(true);
    try {
      const res = await fetchAllBuildersByProductId(productUuid);
      const all = res.data.data || [];

      const nameMap = new Map();
      all.forEach((c) => {
        const existing = nameMap.get(c.checklistName);
        if (!existing || c.revisionNo > existing.revisionNo) {
          nameMap.set(c.checklistName, c);
        }
      });
      const uniqueNames = Array.from(nameMap.values());
      setChecklists(uniqueNames);
      setRevisions(all);

      if (preselectUuid) {
        const selected = all.find((c) => c.uuid === preselectUuid);
        if (selected) {
          form.setFieldsValue({
            checklistName: selected.checklistName,
            checklist: selected.uuid,
          });
          applyChecklist(selected, observations);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getRevisionsForName = (name) =>
    revisions
      .filter((c) => c.checklistName === name)
      .sort((a, b) => b.revisionNo - a.revisionNo);

  const applyChecklist = (checklist, observations) => {
    const nc = detectColCount(checklist.records || []);
    setColCount(nc);
    let g = recordsToGrid(checklist.records || [], nc);
    if (observations) g = applyObservations(g, observations);
    setGrid(g);
  };

  const patchCell = (ri, ci, patch) => {
    setGrid((prev) =>
      prev.map((row, rIdx) =>
        rIdx !== ri
          ? row
          : {
              ...row,
              cells: row.cells.map((c, cIdx) =>
                cIdx !== ci
                  ? c
                  : {
                      ...c,
                      ...(typeof patch === "function" ? patch(c) : patch),
                    },
              ),
            },
      ),
    );
  };

  const capturePhoto = () => {
    if (!webcamRef.current || !camTarget) return;
    const src = webcamRef.current.getScreenshot();
    patchCell(camTarget.ri, camTarget.ci, (c) => ({
      liveImages: [...(c.liveImages || []), src],
    }));
    setCamTarget(null);
  };

  // ── QR scanner ────────────────────────────────────────────────────────────
  //
  // CHANGE 5: Rewrote startQrScanning() with four key improvements:
  //
  //   a) MAX_DIM raised from 1000 → 2000.
  //      Why: A 5mm QR code at 20cm distance is ~100×100px on a 1920-wide
  //      sensor. Scaling to 1000px throws away half those pixels. 2000px
  //      preserves full sensor detail while still being manageable for jsQR.
  //
  //   b) Frame throttle: only run the full decode every 3rd RAF tick.
  //      Why: Prevents thermal throttle on phones which drops camera quality
  //      mid-scan — a major cause of "it stops working after 10 seconds".
  //
  //   c) Replaced inline jsQR call with tryDecodeMultiScale() (see above).
  //      Why: Centre-crop approach doubles/quadruples effective QR pixel size,
  //      making tiny codes detectable.
  //
  //   d) Added live debug text so users know the scanner is active.
  //
  const startQrScanning = useCallback(() => {
    setQrError("");
    setQrDebugInfo("Starting camera…");
    qrFrameCountRef.current = 0;

    if (!qrCanvasRef.current) {
      qrCanvasRef.current = document.createElement("canvas");
    }
    const canvas = qrCanvasRef.current;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });

    const tick = () => {
      const video = qrWebcamRef.current?.video;
      if (!video || video.readyState !== video.HAVE_ENOUGH_DATA) {
        setQrDebugInfo("Waiting for camera…");
        qrRafRef.current = requestAnimationFrame(tick);
        return;
      }

      // CHANGE 5a: Raised MAX_DIM from 1000 to 2000 to preserve more detail
      // for small QR codes. jsQR handles 2000px frames fine on modern phones.
      const MAX_DIM = 2000;
      const vw = video.videoWidth;
      const vh = video.videoHeight;
      if (!vw || !vh) {
        qrRafRef.current = requestAnimationFrame(tick);
        return;
      }
      const scale = Math.min(1, MAX_DIM / Math.max(vw, vh));
      const w = Math.round(vw * scale);
      const h = Math.round(vh * scale);

      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }

      // CHANGE 5b: Throttle — only decode every 3rd frame (~20fps decode rate).
      // Every frame still draws to canvas so the video preview stays smooth.
      ctx.drawImage(video, 0, 0, w, h);
      qrFrameCountRef.current += 1;

      if (qrFrameCountRef.current % 3 !== 0) {
        qrRafRef.current = requestAnimationFrame(tick);
        return;
      }

      setQrDebugInfo(`Scanning… (frame ${qrFrameCountRef.current})`);

      // CHANGE 5c: Use multi-scale decode with preprocessing instead of
      // single-pass jsQR on the raw full-resolution frame.
      const code = tryDecodeMultiScale(ctx, w, h);

      if (code?.data) {
        stopQrScanning();
        parseAndFillQr(code.data);
        return;
      }

      qrRafRef.current = requestAnimationFrame(tick);
    };

    qrRafRef.current = requestAnimationFrame(tick);
  }, []);

  const stopQrScanning = useCallback(() => {
    if (qrRafRef.current) {
      cancelAnimationFrame(qrRafRef.current);
      qrRafRef.current = null;
    }
    setQrDebugInfo("");
  }, []);

  // ── Camera enumeration ────────────────────────────────────────────────────
  //
  // detectCameras — enumerate video inputs and pick the rear camera.
  // FIX: The previous version always silently fell back to "last device = rear"
  // which is correct on phones but wrong on desktops/laptops (only one camera,
  // and it is the front webcam — exactly what you see in the screenshot).
  // New strategy:
  //   • If a device label explicitly says "back/rear/environment" → use it,
  //     no picker needed (reliable on most Android phones with proper labels).
  //   • If multiple cameras but none labelled as rear → pick the last one AND
  //     show the camera picker so the user can correct it if wrong.
  //   • If only one camera (desktop/laptop) → use it AND show the picker with
  //     a hint that an external/rear camera may be needed.
  const detectCameras = useCallback(async () => {
    try {
      const tmpStream = await navigator.mediaDevices.getUserMedia({ video: true });
      tmpStream.getTracks().forEach((t) => t.stop());

      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter((d) => d.kind === "videoinput");
      setQrDeviceList(videoInputs);

      if (videoInputs.length === 0) {
        setQrDeviceId(null);
        return;
      }

      const back = videoInputs.find((d) =>
        /back|rear|environment/i.test(d.label || ""),
      );

      if (back) {
        // Confident label match — no picker needed.
        const idx = videoInputs.findIndex((d) => d.deviceId === back.deviceId);
        setQrDeviceId(back.deviceId);
        setQrDeviceIdx(idx >= 0 ? idx : 0);
        setShowCameraPicker(false);
      } else {
        // Cannot confidently determine which is rear — default to last device
        // (correct on phones, wrong on desktops) and show the picker.
        const chosen = videoInputs[videoInputs.length - 1];
        const idx = videoInputs.length - 1;
        setQrDeviceId(chosen.deviceId);
        setQrDeviceIdx(idx);
        setShowCameraPicker(true);
      }
    } catch (e) {
      setQrDeviceId(null);
      setQrDeviceList([]);
      setShowCameraPicker(false);
    }
  }, []);

  // CHANGE 7: enableTorch() — attempt to enable the phone's flashlight after
  // the Webcam component has started the video stream.
  // Why: Consistent, close-range illumination is the single biggest factor for
  // reading small QR codes. Auto-exposure without torch often causes the camera
  // to over-expose or under-expose the tiny code area.
  // We silently ignore errors because torch is not available on all devices/browsers.
  const enableTorch = useCallback(async () => {
    try {
      const video = qrWebcamRef.current?.video;
      if (!video) return;
      const stream = video.srcObject;
      if (!stream) return;
      const track = stream.getVideoTracks()[0];
      if (!track) return;
      const capabilities = track.getCapabilities?.();
      if (capabilities?.torch) {
        await track.applyConstraints({ advanced: [{ torch: true }] });
      }
    } catch {
      // torch not supported — ignore silently
    }
  }, []);

  const switchCamera = useCallback(() => {
    if (qrDeviceList.length < 2) return;
    stopQrScanning();
    const nextIdx = (qrDeviceIdx + 1) % qrDeviceList.length;
    setQrDeviceIdx(nextIdx);
    setQrDeviceId(qrDeviceList[nextIdx].deviceId);
  }, [qrDeviceList, qrDeviceIdx, stopQrScanning]);

  const checkForExistingRecord = async ({
    checklistId,
    serial,
    po,
    onClose,
  }) => {
    if (!checklistId || !serial || !po) return false;

    try {
      const res = await checkExistingExecution({
        checklistId,
        poNumber: po,
        serialNumber: serial,
      });
      const existing = res?.status === 204 ? null : res?.data;

      if (!existing) return false;

      onClose?.();

      Modal.confirm({
        title: "Record already exists",
        icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
        width: 480,
        content: (
          <div style={{ fontSize: 13 }}>
            <p>
              The record already exists for{" "}
              <strong>{existing.checklist?.checklistName}</strong> — Serial:{" "}
              <strong>{existing.serialNumber}</strong>, PO:{" "}
              <strong>{existing.poNumber}</strong>. Do you want to edit?
            </p>
            <div
              style={{
                marginTop: 12,
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              <div
                style={{
                  padding: "10px 14px",
                  borderRadius: 6,
                  border: "1px solid #d9d9d9",
                  background: "#f0f5ff",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
                  Edit existing
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Open the existing record (Rev {existing.revisionNo || 1}) and
                  correct it.
                </div>
              </div>
              <div
                style={{
                  padding: "10px 14px",
                  borderRadius: 6,
                  border: "1px solid #d9d9d9",
                  background: "#fff7e6",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
                  New revision
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Keep the old record, create Rev{" "}
                  {(existing.revisionNo || 1) + 1} for re-inspection.
                </div>
              </div>
            </div>
          </div>
        ),
        okText: "New revision",
        cancelText: "Edit existing",
        footer: (_, { OkBtn, CancelBtn }) => (
          <>
            <Button onClick={() => Modal.destroyAll()}>Cancel</Button>
            <CancelBtn />
            <OkBtn />
          </>
        ),
        onOk: () =>
          navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
            state: { revisionMode: "REVISION" },
          }),
        onCancel: () =>
          navigate(`/check-list-builder/check-list/edit/${existing.id}`, {
            state: { revisionMode: "EDIT" },
          }),
      });
      return true;
    } catch {
      return false;
    }
  };

  const parseAndFillQr = async (raw) => {
    const parts = raw.split("!");
    if (parts.length !== 3) {
      setQrError(
        `Invalid QR format. Expected 3 values separated by "!". Got: "${raw}"`,
      );
      startQrScanning();
      return;
    }
    const [serial, po, model] = parts.map((p) => p.trim());

    const checklistId = form.getFieldValue("checklist");

    const found = await checkForExistingRecord({
      checklistId,
      serial,
      po,
      onClose: () => setQrScanOpen(false),
    });
    if (found) return;

    form.setFieldsValue({
      serialNumber: serial,
      poNumber: po,
      modelNumber: model,
    });
    setExistingChecked(true);
    setQrScanOpen(false);
    messageApi.open({
      type: "success",
      content: `No existing record found — QR scanned (Serial: ${serial} | PO: ${po} | Model: ${model}). You can proceed.`,
    });
  };

  const [checkingExisting, setCheckingExisting] = useState(false);
  const handleCheckExisting = async () => {
    const checklistId = form.getFieldValue("checklist");
    const serial = (form.getFieldValue("serialNumber") || "").trim();
    const po = (form.getFieldValue("poNumber") || "").trim();

    if (!checklistId) {
      messageApi.open({
        type: "warning",
        content: "Select checklist template and revision first",
      });
      return;
    }
    if (!serial || !po) {
      messageApi.open({
        type: "warning",
        content: "Enter Serial Number and PO Number first",
      });
      return;
    }

    setCheckingExisting(true);
    try {
      const found = await checkForExistingRecord({ checklistId, serial, po });
      if (!found) {
        setExistingChecked(true);
        messageApi.open({
          type: "success",
          content: "No existing record found — you can proceed.",
        });
      }
    } finally {
      setCheckingExisting(false);
    }
  };

  const openQrScanner = () => {
    if (!form.getFieldValue("checklist")) {
      messageApi.open({
        type: "warning",
        content: "Select checklist template and revision first",
      });
      return;
    }
    setQrError("");
    setQrDebugInfo("");
    setQrUseExact(true);
    setQrScanOpen(true);
    detectCameras();
  };

  const closeQrScanner = () => {
    stopQrScanning();
    setQrScanOpen(false);
  };

  const onFinish = async (values) => {
    if (mode !== "view" && !editData && !existingChecked) {
      messageApi.open({
        type: "warning",
        content:
          "Please click \"Check Existing\" (or Scan QR) before submitting.",
      });
      return;
    }

    const allCells = grid
      .flatMap((row) => row.cells)
      .filter((c) => {
        if (c.hidden) return false;
        if (!c.id || String(c.id).startsWith("empty_")) return false;
        return c.cellType === "INPUT" && c.isMandatory === true;
      });

    const missingMandatoryImages = allCells.filter(
      (c) => c.inputType === "LIVE_IMAGE" && !c.liveImages?.length,
    );

    if (missingMandatoryImages.length > 0) {
      messageApi.open({
        type: "error",
        content: `${missingMandatoryImages.length} mandatory image field(s) require at least one photo.`,
      });
      return;
    }

    const isEmptyValue = (c) => {
      const v = c.value;
      if (v === null || v === undefined) return true;
      if (c.inputType === "OK_NOT_OK") return v !== true && v !== false;
      if (typeof v === "string") return v.trim() === "";
      return false;
    };

    const missingMandatoryFields = allCells.filter(
      (c) => c.inputType !== "LIVE_IMAGE" && isEmptyValue(c),
    );

    if (missingMandatoryFields.length > 0) {
      messageApi.open({
        type: "error",
        content: `${missingMandatoryFields.length} mandatory field(s) are empty. Please fill them before submitting.`,
      });
      return;
    }

    const observations = grid.flatMap((row) =>
      row.cells
        .filter((c) => {
          if (c.hidden) return false;
          if (!c.id || String(c.id).startsWith("empty_")) return false;
          return c.cellType === "INPUT";
        })
        .map((c) => ({
          recordId: c.id,
          inputType: c.inputType || "STRING",
          value: c.inputType === "LIVE_IMAGE" ? null : c.value,
          liveImages: c.inputType === "LIVE_IMAGE" ? c.liveImages || [] : [],
        })),
    );

    const payload = {
      productId: values.product,
      checklistId: values.checklist,
      serialNumber: values.serialNumber,
      poNumber: values.poNumber,
      modelNumber: values.modelNumber,
      observations,
      revisionMode: editData ? navRevisionMode || "EDIT" : null,
    };

    const resetFields = () => {
      form.setFieldsValue({ serialNumber: "", poNumber: "", modelNumber: "" });
      setGrid((prev) =>
        prev.map((row) => ({
          ...row,
          cells: row.cells.map((cell) =>
            cell.cellType === "INPUT"
              ? { ...cell, value: null, liveImages: [] }
              : cell,
          ),
        })),
      );
    };

    const doSubmit = async (finalPayload) => {
      if (editData) {
        await putExecution(finalPayload, editData.id);
        messageApi.open({
          type: "success",
          content: "Execution saved successfully",
        });
        navigate(
          { pathname: "/check-list-builder/check-list" },
          { replace: true },
        );
      } else {
        await postExecution(finalPayload);
        messageApi.open({
          type: "success",
          content: "Execution saved successfully",
        });
        resetFields();
      }
    };

    setIsLoading(true);
    try {
      await doSubmit(payload);
    } catch (err) {
      const serverMsg = err?.response?.data?.message || err?.message || "";

      if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE_OTHER:")) {
        setIsLoading(false);
        const checklistName =
          revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
          values.checklist;

        Modal.error({
          title: "Cannot save this execution",
          width: 480,
          content: (
            <div style={{ fontSize: 13 }}>
              <p>
                Another execution already exists for{" "}
                <strong>{checklistName}</strong> — Serial:{" "}
                <strong>{values.serialNumber}</strong>, PO:{" "}
                <strong>{values.poNumber}</strong>.
              </p>
              <p style={{ marginTop: 8 }}>
                Please choose a different checklist/revision for this
                execution, or edit that other record directly from the
                execution list.
              </p>
            </div>
          ),
          okText: "OK",
        });
      } else if (err?.response?.status === 409 && serverMsg.startsWith("DUPLICATE:")) {
        setIsLoading(false);
        const checklistName =
          revisions.find((c) => c.uuid === values.checklist)?.checklistName ||
          values.checklist;

        Modal.confirm({
          title: "Execution already exists",
          icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
          width: 480,
          content: (
            <div style={{ fontSize: 13 }}>
              <p>
                An execution already exists for <strong>{checklistName}</strong>{" "}
                — Serial: <strong>{values.serialNumber}</strong>, PO:{" "}
                <strong>{values.poNumber}</strong>.
              </p>
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div
                  style={{
                    padding: "10px 14px",
                    borderRadius: 6,
                    border: "1px solid #d9d9d9",
                    background: "#f0f5ff",
                  }}
                >
                  <div
                    style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
                  >
                    Edit existing
                  </div>
                  <div style={{ fontSize: 12, color: "#666" }}>
                    Overwrite the current execution. Use to correct a mistake.
                  </div>
                </div>
                <div
                  style={{
                    padding: "10px 14px",
                    borderRadius: 6,
                    border: "1px solid #d9d9d9",
                    background: "#fff7e6",
                  }}
                >
                  <div
                    style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}
                  >
                    New revision
                  </div>
                  <div style={{ fontSize: 12, color: "#666" }}>
                    Keep the old execution, create a new one. Use for
                    re-inspection.
                  </div>
                </div>
              </div>
            </div>
          ),
          okText: "New revision",
          cancelText: "Edit existing",
          onOk: async () => {
            setIsLoading(true);
            try {
              await doSubmit({ ...payload, revisionMode: "REVISION" });
            } catch (e2) {
              messageApi.open({
                type: "error",
                content: e2?.response?.data?.message || "Error saving",
              });
            } finally {
              setIsLoading(false);
            }
          },
          onCancel: async () => {
            setIsLoading(true);
            try {
              await doSubmit({ ...payload, revisionMode: "EDIT" });
            } catch (e2) {
              messageApi.open({
                type: "error",
                content: e2?.response?.data?.message || "Error saving",
              });
            } finally {
              setIsLoading(false);
            }
          },
        });
      } else {
        messageApi.open({
          type: "error",
          content: serverMsg || "Error saving execution",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ── Excel Download using ExcelJS (supports embedded images) ──────────────
  const downloadExcel = async () => {
    setIsLoading(true);
    try {
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("Execution");

      ws.columns = Array.from({ length: colCount }, () => ({ width: 28 }));

      const thinBorder = { style: "thin", color: { argb: "FFAAAAAA" } };
      const medBorder = { style: "medium", color: { argb: "FF333333" } };
      const applyBorder = (cell, type = "thin") => {
        const b = type === "medium" ? medBorder : thinBorder;
        cell.border = { top: b, bottom: b, left: b, right: b };
      };

      const headerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD6E4F0" },
      };
      const sectionFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE8F0FE" },
      };
      const whiteFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" },
      };

      ws.mergeCells(1, 1, 1, colCount);
      const titleCell = ws.getCell(1, 1);
      titleCell.value = "Checklist Execution Report";
      titleCell.font = { bold: true, size: 13, color: { argb: "FF1F3864" } };
      titleCell.fill = headerFill;
      titleCell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      applyBorder(titleCell, "medium");
      ws.getRow(1).height = 28;

      ws.getRow(2).height = 6;

      const meta = [
        ["Serial Number", editData?.serialNumber ?? ""],
        ["PO Number", editData?.poNumber ?? ""],
        ["Model Number", editData?.modelNumber ?? ""],
        ["Product", editData?.product?.productName ?? ""],
        ["Checklist", editData?.checklist?.checklistName ?? ""],
        [
          "Created Date",
          editData?.createdDate
            ? new Date(editData.createdDate).toLocaleString()
            : "",
        ],
      ];
      meta.forEach(([label, val], i) => {
        const rowIdx = 3 + i;
        const lCell = ws.getCell(rowIdx, 1);
        const vCell = ws.getCell(rowIdx, 2);
        lCell.value = label;
        lCell.font = { bold: true, size: 11 };
        vCell.value = val;
        vCell.font = { size: 11 };
        [lCell, vCell].forEach((c) => {
          c.alignment = { vertical: "middle", wrapText: true };
          applyBorder(c);
        });
        ws.getRow(rowIdx).height = 18;
      });

      ws.getRow(7).height = 6;

      const INFO_ROWS = 9;
      const mergedCells = new Set();

      const getImageDimensions = (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.onload = () =>
            resolve({ w: img.naturalWidth, h: img.naturalHeight });
          img.onerror = () => resolve({ w: 200, h: 150 });
          img.src = src;
        });

      const imageQueue = [];

      grid.forEach((row, ri) => {
        const sheetRow = INFO_ROWS + ri + 1;
        let colCursor = 1;

        row.cells.forEach((cell) => {
          if (cell.hidden) return;

          const cs = cell.colSpan || 1;
          const rs = cell.rowSpan || 1;
          const sheetCol = colCursor;

          for (let dr = 0; dr < rs; dr++) {
            for (let dc = 0; dc < cs; dc++) {
              if (dr === 0 && dc === 0) continue;
              mergedCells.add(`${sheetRow + dr}_${sheetCol + dc}`);
            }
          }

          if (cs > 1 || rs > 1) {
            ws.mergeCells(
              sheetRow,
              sheetCol,
              sheetRow + rs - 1,
              sheetCol + cs - 1,
            );
          }

          const wsCell = ws.getCell(sheetRow, sheetCol);
          wsCell.alignment = {
            vertical: "middle",
            horizontal: "left",
            wrapText: true,
          };
          applyBorder(wsCell);

          if (cell.cellType === "HEADER") {
            wsCell.value = cell.label || cell.description || "";
            wsCell.font = { bold: true, size: 11, color: { argb: "FF1677FF" } };
            wsCell.fill = sectionFill;
            wsCell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
          } else if (cell.cellType === "DESCRIPTION") {
            wsCell.value = cell.description || "";
            wsCell.font = { size: 11 };
            wsCell.fill = whiteFill;
          } else if (cell.cellType === "INPUT") {
            wsCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFFFBE6" },
            };

            if (cell.inputType === "LIVE_IMAGE") {
              wsCell.value = "";
              (cell.liveImages || []).forEach((src) => {
                imageQueue.push({ sheetRow, sheetCol, cs, rs, src });
              });
            } else if (cell.inputType === "DATE") {
              const v = cell.value;
              if (v) {
                const d = dayjs(v, "DD/MM/YYYY");
                wsCell.value = d.isValid() ? d.toDate() : String(v);
                wsCell.numFmt = "dd/mm/yyyy";
              } else {
                wsCell.value = "";
              }
              wsCell.font = { size: 11 };
            } else {
              const v = cell.value;
              if (v === null || v === undefined) wsCell.value = "";
              else if (typeof v === "boolean")
                wsCell.value = v ? "OK" : "NOT OK";
              else wsCell.value = String(v);
              wsCell.font = { size: 11 };
            }
          } else if (cell.cellType === "IMAGE") {
            wsCell.value = "";
            wsCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF6FFED" },
            };
            (cell.sampleImages || []).forEach((img) => {
              imageQueue.push({ sheetRow, sheetCol, cs, rs, src: img.url });
            });
          }

          colCursor += cs;
        });

        ws.getRow(sheetRow).height = 20;
      });

      const cellImageMap = new Map();
      imageQueue.forEach((item) => {
        const key = `${item.sheetRow}_${item.sheetCol}`;
        if (!cellImageMap.has(key)) cellImageMap.set(key, []);
        cellImageMap.get(key).push(item);
      });

      for (const [, items] of cellImageMap) {
        await Promise.all(
          items.map(async (item) => {
            item.dims = await getImageDimensions(item.src);
          }),
        );
      }

      const PX_TO_PT = 0.75;
      const MAX_ROW_PT = 400;
      const MIN_ROW_PT = 60;

      const rowMaxPx = new Map();
      for (const [, items] of cellImageMap) {
        for (const { sheetRow, dims } of items) {
          const cur = rowMaxPx.get(sheetRow) || 0;
          if (dims.h > cur) rowMaxPx.set(sheetRow, dims.h);
        }
      }

      for (const [sheetRow, maxPx] of rowMaxPx) {
        const pt = Math.min(Math.max(maxPx * PX_TO_PT, MIN_ROW_PT), MAX_ROW_PT);
        ws.getRow(sheetRow).height = pt;
      }

      const COL_CHAR_TO_PX = 7;
      const COL_WIDTH_CHARS = 28;
      const COL_WIDTH_PX = COL_WIDTH_CHARS * COL_CHAR_TO_PX;

      for (const [, items] of cellImageMap) {
        const { sheetRow, sheetCol, cs, rs } = items[0];
        const count = items.length;

        const cellWidthPx = COL_WIDTH_PX * cs;
        const slotWidthPx = cellWidthPx / count;
        const rowHeightPx = rowMaxPx.get(sheetRow) || 150;

        for (let idx = 0; idx < count; idx++) {
          const { src, dims } = items[idx];
          const raw = toRawBase64(src);
          const ext = detectExt(src);
          if (!raw) continue;

          const scaledH = slotWidthPx * (dims.h / dims.w);
          const rowFraction = Math.min(scaledH / rowHeightPx, 1) * rs;

          const colFractionStart = sheetCol - 1 + idx * (cs / count);
          const colFractionEnd = sheetCol - 1 + (idx + 1) * (cs / count);

          try {
            const imageId = wb.addImage({ base64: raw, extension: ext });
            ws.addImage(imageId, {
              tl: { col: colFractionStart, row: sheetRow - 1 },
              br: { col: colFractionEnd, row: sheetRow - 1 + rowFraction },
              editAs: "oneCell",
            });
          } catch (e) {
            const wsCell = ws.getCell(sheetRow, sheetCol);
            wsCell.value = `[${count} image(s)]`;
          }
        }
      }

      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const safeSerial = (editData?.serialNumber ?? String(id)).replace(
        /[/\\?*[\]]/g,
        "_",
      );
      saveAs(blob, `checklist_execution_${safeSerial}_${Date.now()}.xlsx`);
    } catch (err) {
      console.error("Excel export error:", err);
      messageApi.open({
        type: "error",
        content: "Failed to generate Excel file",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Spin spinning={isLoading}>
      {contextHolder}

      {/* Photo capture modal */}
      <Modal
        open={!!camTarget}
        title="Capture Photo"
        onCancel={() => setCamTarget(null)}
        footer={[
          <Button
            key="cap"
            type="primary"
            icon={<CameraOutlined />}
            onClick={capturePhoto}
          >
            Capture
          </Button>,
          <Button key="cls" onClick={() => setCamTarget(null)}>
            Close
          </Button>,
        ]}
      >
        <Webcam
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          style={{ width: "100%" }}
        />
      </Modal>

      {/* Image preview modal */}
      <Modal
        open={!!previewSrc}
        footer={null}
        onCancel={() => setPreviewSrc(null)}
        title="Image Preview"
      >
        <img src={previewSrc} alt="preview" style={{ width: "100%" }} />
      </Modal>

      {/* QR Scanner modal */}
      <Modal
        open={qrScanOpen}
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <QrcodeOutlined /> Scan QR Code
          </span>
        }
        onCancel={closeQrScanner}
        // CHANGE 8: afterOpenChange now also calls enableTorch() after the
        // webcam starts. Why: torch can only be applied after the stream is
        // active; calling it in afterOpenChange gives the Webcam component
        // time to mount and negotiate the camera stream before we attempt
        // to apply advanced constraints.
        afterOpenChange={(open) => {
          if (open) {
            startQrScanning();
            // Small delay so the webcam stream is fully negotiated before
            // we try to apply torch constraint.
            setTimeout(enableTorch, 1200);
          } else {
            stopQrScanning();
          }
        }}
        footer={[
          ...(qrDeviceList.length > 1
            ? [
                <Button key="switch" onClick={switchCamera}>
                  Switch Camera
                </Button>,
              ]
            : []),
          <Button key="cls" onClick={closeQrScanner}>
            Close
          </Button>,
        ]}
        width={480}
      >
        <div style={{ textAlign: "center" }}>

          {/* FIX: Camera picker — shown when auto-detection cannot confidently
              identify the rear camera (e.g. desktop with front webcam only, or
              Android with generic "Camera 0/1" labels).
              The user selects the correct camera from a dropdown; changing the
              selection re-mounts the Webcam via the `key` prop so the browser
              negotiates a new stream from the chosen device. */}
          {showCameraPicker && qrDeviceList.length > 0 && (
            <div style={{
              marginBottom: 10, padding: "8px 12px", borderRadius: 6,
              background: "#fffbe6", border: "1px solid #ffe58f",
              fontSize: 12, color: "#876800", textAlign: "left",
            }}>
              <div style={{ marginBottom: 6, fontWeight: 600 }}>
                📷 Select camera — auto-detection could not identify the rear camera:
              </div>
              <Select
                size="small"
                style={{ width: "100%" }}
                value={qrDeviceId}
                onChange={(deviceId) => {
                  stopQrScanning();
                  const idx = qrDeviceList.findIndex((d) => d.deviceId === deviceId);
                  setQrDeviceId(deviceId);
                  setQrDeviceIdx(idx >= 0 ? idx : 0);
                }}
              >
                {qrDeviceList.map((d, i) => (
                  <Option key={d.deviceId} value={d.deviceId}>
                    {d.label || `Camera ${i + 1}`}
                  </Option>
                ))}
              </Select>
              <div style={{ marginTop: 4, fontSize: 11, color: "#ad6800" }}>
                On a phone: choose the <strong>back / rear</strong> camera. On a desktop: use a phone instead for best results.
              </div>
            </div>
          )}

          {/* Video feed with aiming overlay on top — FIX: the overlay div must
              wrap the Webcam so position:absolute is relative to the video.
              Previously the overlay div was AFTER the Webcam div so it rendered
              below the video instead of on top of it. */}
          {qrScanOpen && (
            <div style={{ position: "relative", display: "inline-block", width: "100%", lineHeight: 0 }}>
              <Webcam
                key={qrDeviceId || (qrUseExact ? "qr-cam-exact" : "qr-cam-fallback")}
                ref={qrWebcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={
                  qrDeviceId
                    ? {
                        deviceId: { exact: qrDeviceId },
                        width: { ideal: 4096 },
                        height: { ideal: 2160 },
                      }
                    : qrUseExact
                      ? {
                          facingMode: { exact: "environment" },
                          width: { ideal: 4096 },
                          height: { ideal: 2160 },
                        }
                      : {
                          facingMode: "environment",
                          width: { ideal: 4096 },
                          height: { ideal: 2160 },
                        }
                }
                onUserMediaError={() => {
                  if (qrDeviceId) {
                    setQrDeviceId(null);
                    setQrUseExact(true);
                    return;
                  }
                  if (qrUseExact) setQrUseExact(false);
                }}
                style={{ width: "100%", borderRadius: 6, display: "block" }}
              />

              {/* Aiming crosshair overlay — position:absolute over the video */}
              <div style={{
                position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                pointerEvents: "none", borderRadius: 6,
              }}>
                <div style={{
                  position: "absolute",
                  top: "50%", left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 160, height: 160,
                }}>
                  {[
                    { top: 0,    left: 0,  borderTop: "3px solid #1677ff", borderLeft:  "3px solid #1677ff" },
                    { top: 0,    right: 0, borderTop: "3px solid #1677ff", borderRight: "3px solid #1677ff" },
                    { bottom: 0, left: 0,  borderBottom: "3px solid #1677ff", borderLeft:  "3px solid #1677ff" },
                    { bottom: 0, right: 0, borderBottom: "3px solid #1677ff", borderRight: "3px solid #1677ff" },
                  ].map((s, i) => (
                    <div key={i} style={{ position: "absolute", width: 28, height: 28, ...s }} />
                  ))}
                </div>
              </div>
            </div>
          )}

          <div style={{ marginTop: 8, fontSize: 12, color: "#888" }}>
            Centre the QR code within the brackets — hold steady, 10–15 cm away
          </div>

          {/* Live scan status */}
          {qrDebugInfo && (
            <div style={{ marginTop: 4, fontSize: 11, color: "#1677ff" }}>
              {qrDebugInfo}
            </div>
          )}

          {qrError && (
            <div style={{
              marginTop: 8, color: "#f5222d", fontSize: 12,
              background: "#fff2f0", borderRadius: 4,
              padding: "6px 10px", border: "1px solid #ffccc7",
            }}>
              {qrError}
            </div>
          )}
          <div style={{ marginTop: 10, fontSize: 11, color: "#aaa" }}>
            Expected format: <code>SERIAL!PONUMBER!MODELNO</code>
          </div>
        </div>
      </Modal>

      <div style={{ fontWeight: 700, fontSize: "1rem", marginBottom: 12 }}>
        Checklist Execution
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={(changed) => {
          if (
            mode !== "view" &&
            !editData &&
            ("serialNumber" in changed ||
              "poNumber" in changed ||
              "checklist" in changed)
          ) {
            setExistingChecked(false);
          }
        }}
      >
        {/* Row 1: Product + Checklist */}
        <Row gutter={16} style={{ marginBottom: 0 }}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="product"
              label="Select Product"
              rules={[{ required: true }]}
            >
              <TreeSelect
                treeData={products}
                placeholder="Select product"
                allowClear
                disabled={mode === "view"}
                onChange={(val) => {
                  form.setFieldsValue({
                    checklistName: undefined,
                    checklist: undefined,
                  });
                  setGrid([]);
                  loadChecklists(val);
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="checklistName"
              label="Select Checklist"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select checklist"
                disabled={mode === "view" || !selectedProduct}
                onChange={(name) => {
                  form.setFieldsValue({ checklist: undefined });
                  setGrid([]);
                  const revs = getRevisionsForName(name);
                  if (revs.length === 1) {
                    form.setFieldsValue({ checklist: revs[0].uuid });
                    applyChecklist(revs[0]);
                  }
                }}
              >
                {checklists.map((c) => (
                  <Option key={c.checklistName} value={c.checklistName}>
                    {c.checklistName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) =>
                prev.checklistName !== curr.checklistName
              }
            >
              {({ getFieldValue }) => {
                const name = getFieldValue("checklistName");
                const revs = name ? getRevisionsForName(name) : [];
                return (
                  <Form.Item
                    name="checklist"
                    label="Revision"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select revision"
                      disabled={mode === "view" || !name}
                      onChange={(uuid) => {
                        const sel = revisions.find((c) => c.uuid === uuid);
                        if (sel) applyChecklist(sel);
                      }}
                    >
                      {revs.map((c) => (
                        <Option key={c.uuid} value={c.uuid}>
                          Rev {c.revisionNo}
                          {c.isLatest ? " ✓" : ""}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {mode !== "view" && !editData && (
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={6}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Form.Item
                noStyle
                shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
              >
                {({ getFieldValue }) => {
                  const checklistSelected = !!getFieldValue("checklist");
                  return (
                    <Form.Item label=" ">
                      <Tooltip
                        title={
                          checklistSelected
                            ? "Scan QR code to auto-fill Serial No, PO No, and Model No"
                            : "Select checklist template and revision first"
                        }
                      >
                        <Button
                          icon={<ScanOutlined />}
                          type="dashed"
                          disabled={!checklistSelected}
                          onClick={openQrScanner}
                          style={{ height: 32 }}
                        >
                          Scan QR
                        </Button>
                      </Tooltip>
                      <span
                        style={{ marginLeft: 10, fontSize: 11, color: "#888" }}
                      >
                        or fill manually below
                      </span>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
          )}
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
            >
              {({ getFieldValue }) => {
                const checklistSelected = !!getFieldValue("checklist");
                return (
                  <Form.Item
                    name="serialNumber"
                    label="Serial Number"
                    rules={[
                      { required: true, message: "Serial number is required" },
                    ]}
                  >
                    <Input
                      disabled={
                        mode === "view" || !!editData || !checklistSelected
                      }
                      placeholder="e.g. BZCW220296"
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
            >
              {({ getFieldValue }) => {
                const checklistSelected = !!getFieldValue("checklist");
                return (
                  <Form.Item
                    name="poNumber"
                    label="PO Number"
                    rules={[
                      { required: true, message: "PO number is required" },
                    ]}
                  >
                    <Input
                      disabled={
                        mode === "view" || !!editData || !checklistSelected
                      }
                      placeholder="e.g. 815136556"
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prev, curr) => prev.checklist !== curr.checklist}
            >
              {({ getFieldValue }) => {
                const checklistSelected = !!getFieldValue("checklist");
                return (
                  <Form.Item
                    name="modelNumber"
                    label="Model Number"
                    rules={[
                      { required: true, message: "Model number is required" },
                    ]}
                  >
                    <Input
                      disabled={
                        mode === "view" || !!editData || !checklistSelected
                      }
                      placeholder="e.g. X990790"
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {mode !== "view" && !editData && (
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={6}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Form.Item
                noStyle
                shouldUpdate={(prev, curr) =>
                  prev.checklist !== curr.checklist ||
                  prev.serialNumber !== curr.serialNumber ||
                  prev.poNumber !== curr.poNumber
                }
              >
                {({ getFieldValue }) => {
                  const checklistSelected = !!getFieldValue("checklist");
                  const hasSerialPo =
                    !!getFieldValue("serialNumber") &&
                    !!getFieldValue("poNumber");
                  return (
                    <Form.Item label=" ">
                      <Tooltip
                        title={
                          checklistSelected
                            ? "Check if a record already exists for this Serial No + PO No"
                            : "Select checklist template and revision first"
                        }
                      >
                        <Button
                          icon={<HistoryOutlined />}
                          onClick={handleCheckExisting}
                          loading={checkingExisting}
                          disabled={!checklistSelected || !hasSerialPo}
                          style={{ height: 32 }}
                        >
                          Check Existing
                        </Button>
                      </Tooltip>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
          )}
        </Row>

        {grid.length > 0 && mode !== "view" && !editData && !existingChecked && (
          <div
            style={{
              marginBottom: 12,
              padding: "8px 12px",
              borderRadius: 6,
              background: "#fffbe6",
              border: "1px solid #ffe58f",
              fontSize: 12,
              color: "#876800",
            }}
          >
            Enter Serial Number and PO Number, then click{" "}
            <strong>Check Existing</strong> (or use <strong>Scan QR</strong>)
            before filling in the checklist below.
          </div>
        )}

        {grid.length > 0 && (
          <div
            style={{
              overflowX: "auto",
              border: "1px solid #d9d9d9",
              borderRadius: 6,
            }}
          >
            <table
              style={{
                borderCollapse: "collapse",
                tableLayout: "fixed",
                width: "100%",
                minWidth: colCount * 180 + 36,
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: 36,
                      background: "#f0f0f0",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                  {Array.from({ length: colCount }, (_, ci) => (
                    <th
                      key={ci}
                      style={{
                        background: "#f0f0f0",
                        border: "1px solid #d9d9d9",
                        padding: "4px 8px",
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#666",
                        textAlign: "center",
                      }}
                    >
                      {String.fromCharCode(65 + ci)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {grid.map((row, ri) => {
                  const visible = row.cells
                    .map((c, ci) => ({ c, ci }))
                    .filter(({ c }) => !c.hidden);
                  const gridLocked =
                    mode !== "view" && !editData && !existingChecked;
                  return (
                    <tr key={row.rowId}>
                      <td
                        style={{
                          width: 36,
                          background: "#fafafa",
                          border: "1px solid #e0e0e0",
                          textAlign: "center",
                          fontSize: 10,
                          color: "#bbb",
                          verticalAlign: "middle",
                        }}
                      >
                        {ri + 1}
                      </td>
                      {visible.map(({ c: cell, ci }) => (
                        <ExecCell
                          key={cell.id || `cell_${ri}_${ci}`}
                          cell={cell}
                          ri={ri}
                          ci={ci}
                          mode={mode}
                          locked={gridLocked}
                          onChange={(p) => patchCell(ri, ci, p)}
                          onCamera={() => setCamTarget({ ri, ci })}
                          onPreview={setPreviewSrc}
                        />
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div
          style={{
            marginTop: 16,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <Button
            onClick={() =>
              navigate(
                { pathname: "/check-list-builder/check-list" },
                { replace: true },
              )
            }
          >
            Cancel
          </Button>
          {mode === "view" && (
            <Button
              icon={<DownloadOutlined />}
              onClick={downloadExcel}
              disabled={!editData}
            >
              Download Excel
            </Button>
          )}
          {mode !== "view" && (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
        </div>
      </Form>
    </Spin>
  );
};

// ─── ExecCell ─────────────────────────────────────────────────────────────────
const CELL_TYPE_META = {
  HEADER: { label: "Header", bg: "#e6f4ff", color: "#1677ff" },
  DESCRIPTION: { label: "Description", bg: "#f5f5f5", color: "#666" },
  INPUT: { label: "Input", bg: "#fffbe6", color: "#7c5b00" },
  IMAGE: { label: "Image", bg: "#f6ffed", color: "#237804" },
};

const INPUT_TYPE_LABEL = {
  STRING: "Text",
  DOUBLE: "Number",
  DATE: "Date",
  OK_NOT_OK: "OK / Not OK",
  OPTIONS: "Options",
  LIVE_IMAGE: "Live Image Capture",
};

const ExecCell = ({ cell, ri, ci, mode, locked, onChange, onCamera, onPreview }) => {
  const tdBase = {
    border: "1px solid #d9d9d9",
    verticalAlign: "top",
    padding: "8px 10px",
    boxSizing: "border-box",
  };

  switch (cell.cellType) {
    case "HEADER":
      return (
        <td
          colSpan={cell.colSpan || 1}
          rowSpan={cell.rowSpan || 1}
          style={{
            ...tdBase,
            background: "#e6f4ff",
            fontWeight: 700,
            color: "#1677ff",
            fontSize: 13,
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          {cell.label || cell.description}
        </td>
      );

    case "DESCRIPTION":
      return (
        <td
          colSpan={cell.colSpan || 1}
          rowSpan={cell.rowSpan || 1}
          style={{
            ...tdBase,
            background: "#fff",
            color: "#333",
            fontSize: 12,
            lineHeight: 1.5,
          }}
        >
          {cell.description}
        </td>
      );

    case "INPUT": {
      const isDisabled = mode === "view" || locked;
      const renderWidget = () => {
        switch (cell.inputType) {
          case "OK_NOT_OK":
            return (
              <div style={{ display: "flex", gap: 12 }}>
                <Checkbox
                  checked={cell.value === true}
                  disabled={isDisabled}
                  onChange={() =>
                    onChange({ value: cell.value === true ? null : true })
                  }
                >
                  OK
                </Checkbox>
                <Checkbox
                  checked={cell.value === false}
                  disabled={isDisabled}
                  onChange={() =>
                    onChange({ value: cell.value === false ? null : false })
                  }
                >
                  NOT OK
                </Checkbox>
              </div>
            );

          case "OPTIONS":
            return (
              <Radio.Group
                value={cell.value}
                disabled={isDisabled}
                style={{ display: "flex", flexDirection: "column", gap: 4 }}
                onChange={(e) => onChange({ value: e.target.value })}
              >
                {(cell.options || []).map((o, i) => (
                  <Radio key={i} value={o}>
                    {o}
                  </Radio>
                ))}
              </Radio.Group>
            );

          case "DOUBLE":
            return (
              <InputNumber
                style={{ width: "100%" }}
                value={cell.value}
                disabled={isDisabled}
                onChange={(v) => onChange({ value: v })}
              />
            );

          case "DATE":
            return (
              <DatePicker
                style={{ width: "100%" }}
                disabled={isDisabled}
                value={cell.value ? dayjs(cell.value, "DD/MM/YYYY") : null}
                format="DD/MM/YYYY"
                onChange={(_, dateStr) => onChange({ value: dateStr || null })}
              />
            );

          case "LIVE_IMAGE":
            return (
              <div>
                {(cell.liveImages || []).length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      gap: 4,
                      flexWrap: "wrap",
                      marginBottom: 6,
                    }}
                  >
                    {(cell.liveImages || []).map((src, i) => (
                      <div key={i} style={{ position: "relative" }}>
                        <img
                          src={src}
                          alt="captured"
                          style={{
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                            borderRadius: 3,
                            cursor: "pointer",
                            border: "1px solid #d9d9d9",
                          }}
                          onClick={() => onPreview(src)}
                        />
                        {mode !== "view" && !locked && (
                          <Button
                            danger
                            type="text"
                            size="small"
                            style={{
                              position: "absolute",
                              top: -4,
                              right: -4,
                              padding: 0,
                              height: 16,
                              width: 16,
                              fontSize: 9,
                              borderRadius: "50%",
                              background: "#fff",
                              border: "1px solid #f5222d",
                            }}
                            onClick={() =>
                              onChange((c) => ({
                                liveImages: c.liveImages.filter(
                                  (_, j) => j !== i,
                                ),
                              }))
                            }
                          >
                            ×
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {mode !== "view" && !locked && (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <Button
                      size="small"
                      type="dashed"
                      icon={<CameraOutlined />}
                      style={{
                        fontSize: 11,
                        borderColor:
                          cell.isMandatory && !cell.liveImages?.length
                            ? "#ff4d4f"
                            : undefined,
                        color:
                          cell.isMandatory && !cell.liveImages?.length
                            ? "#ff4d4f"
                            : undefined,
                      }}
                      onClick={onCamera}
                    >
                      {cell.isMandatory ? "Capture (required)" : "Capture"}
                    </Button>
                    {cell.isMandatory && !cell.liveImages?.length && (
                      <span style={{ fontSize: 10, color: "#ff4d4f" }}>
                        At least 1 photo required
                      </span>
                    )}
                  </div>
                )}
                {(mode === "view" || locked) && !cell.liveImages?.length && (
                  <span style={{ fontSize: 11, color: "#bbb" }}>
                    No images captured
                  </span>
                )}
              </div>
            );

          default:
            return (
              <Input.TextArea
                autoSize={{ minRows: 1, maxRows: 6 }}
                value={cell.value ?? ""}
                disabled={isDisabled}
                onChange={(e) => onChange({ value: e.target.value })}
              />
            );
        }
      };

      return (
        <td
          colSpan={cell.colSpan || 1}
          rowSpan={cell.rowSpan || 1}
          style={{ ...tdBase, background: "#fffbe6" }}
        >
          {renderWidget()}
          {cell.isMandatory &&
            cell.inputType !== "LIVE_IMAGE" &&
            mode !== "view" && (
              <div style={{ marginTop: 3, fontSize: 10, color: "#d46b08" }}>
                * required
              </div>
            )}
        </td>
      );
    }

    case "IMAGE":
      return (
        <td
          colSpan={cell.colSpan || 1}
          rowSpan={cell.rowSpan || 1}
          style={{ ...tdBase, background: "#f6ffed" }}
        >
          {cell.sampleImages?.length > 0 ? (
            <div>
              <div style={{ fontSize: 10, color: "#888", marginBottom: 4 }}>
                Reference
              </div>
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                {cell.sampleImages.map((img, i) => (
                  <img
                    key={i}
                    src={img.url}
                    alt="ref"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: 3,
                      cursor: "pointer",
                      border: "1px solid #b7eb8f",
                      opacity: 0.85,
                    }}
                    onClick={() => onPreview(img.url)}
                  />
                ))}
              </div>
            </div>
          ) : (
            <span style={{ fontSize: 11, color: "#bbb" }}>
              No reference images
            </span>
          )}
        </td>
      );

    default:
      return (
        <td
          colSpan={cell.colSpan || 1}
          rowSpan={cell.rowSpan || 1}
          style={{ ...tdBase, background: "#fff" }}
        />
      );
  }
};

export default ChecklistExecutionGridForm;